import React, { useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { CircularProgress } from "@mui/material";
import uRLs from "../../baseUtils";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import Convertinvoice from "../../../components/pages/sale/ConvertInvoice";
import InvoiceInfoSidebar from "../a4Invoices/common/InvoiceInfoSidebar";
import InvoiceToggleActionCard from "../a4Invoices/common/InvoiceToggleActionCard";
import InvoicePreviewRenderer from "./common/InvoiceHA4PreviewRender";
import PaySettleModal from "./common/PaySettleModal ";
import InvoiceModalLayout from "./common/InvoiceModalLayout ";
import { useInvoiceData } from "./common/useInvoiceData";
import {
  capitalizeFirstLetter,  
  loadImageDimensions,  
} from "./common/invoiceUtils";
import ReturnSaleInvoice from "./ReturnSaleInvoice";
import { useShowAlert } from "../../../context/AlertContext";
import { useNetwork } from "../../../context/NetworkContext";
import AxiosInstance from "../../AxiosInstance";
import handleError from "../../../constants/handleError";

const ProfessionalGSTInvoice = ({
  isData,
  selectedOption,
  onClose,
  onDataUpdate,
  onDataChange,
  onListSaleRefresh,
  isActive,
  optData,
  setOptData,
}) => {
  
  const invoiceData = useInvoiceData({
    isData,
    onClose,
    onDataUpdate,
    onDataChange,
    optData,
    setOptData,
  });
  const {
    data,
    globalData,
    qrCodeDataUrl,
    selectedTheme,
    selectedSize,
    setSelectedSize,
    terms,
    latestVersion,
    formatTrackMode,
    download,
    setDownload,
    billing,
    setBilling,
    selectTermalOption,
    setSelectTermalOption,
    selectHALFA4Option,
    setSelectHALFA4Option,
    isBtnLoading,
    setBtnLoading,
    isPaySettleModalOpen,
    setIsPaySettleModalOpen,
    isMainModalOpen,
    setIsMainModalOpen,
    saleLoading,
    closeAuto,
    setCloseAuto,
    showConfirm,
    setShowConfirm,
    handleResetSale,
    saleTime,
    storeSettings,
    handleSelectedSale,
    handlelatestSale,
    isBillReceipt,
    documentTitle,
    handleGenerateInvoice,
    handleModeConfirm,
    isProforma,
    documentConfig,
    isBill_isTax,
    isPreSale
  } = invoiceData;
 
  const [returnData, setIsReturnData] = useState("");
  const [isReturnView, setIsReturnView] = useState(false);
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const handleClose = () => {
    setIsMainModalOpen(false);
    setIsReturnView(false);
    onClose();
  };
  const handleSelectedReturnSale = async (sale) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/salereturn/${sale?._id}`,
      );
      setIsReturnData(response.data.results);
      setIsReturnView(true);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };


  const generateBillingPDF = async () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const padding = 7;
    const headerX = 2;
    const headerY = 2;
    const imagePath = uRLs?.IMAGE_URL + "profile/" + documentConfig?.image;

    if (documentConfig?.image) {
      try {
        // Convert image URL to base64
        const response = await fetch(imagePath);
        const blob = await response.blob();
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        // Load original dimensions
        const { width: naturalWidth, height: naturalHeight } =
          await loadImageDimensions(base64);

        // Resize logic
        const maxWidth = 50;
        const maxHeight = 10;
        let imgWidth = naturalWidth;
        let imgHeight = naturalHeight;
        const widthRatio = maxWidth / imgWidth;
        const heightRatio = maxHeight / imgHeight;
        const ratio = Math.min(widthRatio, heightRatio);
        imgWidth *= ratio;
        imgHeight *= ratio;

        const getImageFormat = (path) => {
          const ext = path.split(".").pop().toLowerCase();
          if (ext === "jpg" || ext === "jpeg") return "JPEG";
          if (ext === "png") return "PNG";
          return "JPEG";
        };
        const format = getImageFormat(imagePath);

        doc.addImage(
          base64,
          format,
          headerX + padding,
          headerY + padding,
          imgWidth,
          imgHeight,
        );
      } catch (err) {
        console.warn("Image failed to load:", err);
      }
    }

    const invoiceFontSize = 20;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(invoiceFontSize);
    const textHeightOffset = invoiceFontSize * 0.55;
    const invoiceTextY = headerY + textHeightOffset;
    const invoiceX = pageWidth - padding;
    const invoiceText = documentTitle && documentTitle;
    const invoiceTextWidth = doc.getTextWidth(invoiceText);
    doc.text(invoiceText, invoiceX, invoiceTextY, { align: "right" });
    if (globalData?.status === "CANCELLED") {
      const cancelledFontSize = invoiceFontSize * 0.6;
      doc.setFontSize(cancelledFontSize);
      doc.setTextColor(220, 53, 69);
      doc.setFont("Inter-Bold", "bold");
      const cancelledX = invoiceX - invoiceTextWidth - 8; // 8 is spacing between words
      doc.text("CANCELLED", cancelledX, invoiceTextY, { align: "right" });
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(invoiceFontSize);
    }
    doc.setFontSize(10);
    const invoiceNoLabel = documentConfig?.numberLabel;
    const invoiceNoValue = documentConfig?.number;
    const invoiceDateLabel = "Date:";
    const invoiceDateValue = saleTime.date;
    // Measure total widths
    const invoiceNoLabelWidth = doc.getTextWidth(invoiceNoLabel);
    const invoiceNoValueWidth = doc.getTextWidth(invoiceNoValue);
    const invoiceDateLabelWidth = doc.getTextWidth(invoiceDateLabel);
    const invoiceDateValueWidth = doc.getTextWidth(invoiceDateValue);
    const gap = 10;
    const innerGap = 2;
    const invoiceRowY = 25;
    const totalTextWidth =
      invoiceNoLabelWidth +
      innerGap +
      invoiceNoValueWidth +
      gap +
      invoiceDateLabelWidth +
      innerGap +
      invoiceDateValueWidth;
    const invoiceRowX = pageWidth - padding - totalTextWidth;
    const lineStartX = padding;
    const lineEndX = invoiceRowX - 5;
    const lineY = invoiceRowY;
    // Middle line
    doc.setDrawColor(selectedTheme?.templateTheme?.primaryColor);
    doc.setLineWidth(2);
    doc.setLineCap("round");
    doc.line(lineStartX, lineY, lineEndX, lineY);
    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceNoLabel, invoiceRowX, invoiceRowY);
    doc.setFont("Inter-Regular", "normal");
    doc.text(
      invoiceNoValue,
      invoiceRowX + invoiceNoLabelWidth + innerGap,
      invoiceRowY,
    );
    const dateX =
      invoiceRowX + invoiceNoLabelWidth + innerGap + invoiceNoValueWidth + gap;
    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceDateLabel, dateX, invoiceRowY);
    doc.setFont("Inter-Regular", "normal");
    doc.text(
      invoiceDateValue,
      dateX + invoiceDateLabelWidth + innerGap,
      invoiceRowY,
    );
    const sectionTop = 35;
    const midX = pageWidth / 2;
    const col1X = padding;
    const col2X = pageWidth / 3 + 2;
    const col3X = (pageWidth / 3) * 2 + 2;
    const showFromDetails = !!(
      documentConfig?.fromData?.title ||
      documentConfig?.fromData?.addressline1 ||
      documentConfig?.fromData?.addressline2 ||
      documentConfig?.fromData?.district ||
      documentConfig?.fromData?.country ||
      documentConfig?.fromData?.pincode ||
      documentConfig?.fromData?.phone ||
      documentConfig?.fromData?.email ||
      documentConfig?.fromData?.gstnumber ||
      documentConfig?.fromData?.fssai ||
      documentConfig?.fromData?.pannumber ||
      documentConfig?.fromData?.state
    );
    // doc.setFont("Inter-Bold", "bold");
    // doc.setFontSize(12);
    // doc.text("Bill From:", padding, sectionTop);
    doc.setFontSize(9);
    const hasSaleToData =
      documentConfig?.toData &&
      (documentConfig?.toData?.name ||
        documentConfig?.toData?.addressline1 ||
        documentConfig?.toData?.addressline2 ||
        documentConfig?.toData?.district ||
        documentConfig?.toData?.country ||
        documentConfig?.toData?.pincode ||
        documentConfig?.toData?.phone ||
        documentConfig?.toData?.email ||
        documentConfig?.toData?.state ||
        documentConfig?.toData?.statecode ||
        documentConfig?.toData?.referenceid);

    const hasShipping =
      documentConfig?.toData?.shippingAddress &&
      (documentConfig?.toData?.shippingAddress?.addressline1 ||
        documentConfig?.toData?.shippingAddress?.addressline2) &&
      optData?.isCustomerDisplay;
    if (hasSaleToData && optData?.isCustomerDisplay) {
      doc.setFontSize(9);
      doc.setFont("Inter-Bold", "bold");
      doc.text(documentConfig?.toLabel, col2X, sectionTop);
    }
    if (hasShipping) {
      doc.setFontSize(9);
      doc.setFont("Inter-Bold", "bold");
      doc.text("Shipping To:", col3X, sectionTop);
    }
    doc.setFontSize(9);
    let fromY = sectionTop;
    let toY = sectionTop + 5;
    let fromDetails = [];
    if (showFromDetails) {
      fromDetails = [
        { bold: true, text: documentConfig?.fromData?.title || "-" },
        // Address will be dynamically split and inserted below
        {
          bold: false,
          text: `Phone: ${documentConfig?.fromData?.phone || "+91"}`,
        },
        {
          bold: false,
          text: `Email: ${documentConfig?.fromData?.email || ""}`,
        },
        {
          bold: true,
          text: `State:`,
          suffix: ` ${documentConfig?.fromData?.state || ""} [ State Code: ${
            documentConfig?.fromData?.statecode || ""
          } ]`,
        },
      ];
    }
    const sectionGap = 12;
    const sectionWidth = pageWidth / 3 - padding - 4;
    if (showFromDetails) {
      const fromAddressWrapWidth = sectionWidth - 10;
      const rawAddress = [
        documentConfig?.fromData?.addressline1,
        documentConfig?.fromData?.addressline2,
        documentConfig?.fromData?.district,
        documentConfig?.fromData?.country,
        documentConfig?.fromData?.pincode
          ? `- ${documentConfig?.fromData.pincode}`
          : "",
      ]
        .filter(Boolean)
        .join(", ");

      // Wrap address to sectionWidth (same used in renderDetails)
      const wrappedAddress = doc.splitTextToSize(
        rawAddress,
        fromAddressWrapWidth,
      );

      // Insert wrapped address lines after the title (index 1)
      wrappedAddress.forEach((line, i) => {
        fromDetails.splice(1 + i, 0, { bold: false, text: line });
      });
    }
    let toDetails = [];
    if (hasSaleToData) {
      toDetails = [
        { bold: true, text: documentConfig?.toData?.name || "-" },
        {
          bold: false,
          text: [
            documentConfig?.toData?.addressline1,
            documentConfig?.toData?.addressline2,
            documentConfig?.toData?.district,
            documentConfig?.toData?.country,
            documentConfig?.toData?.pincode
              ? `- ${documentConfig?.toData.pincode}`
              : "",
          ]
            .filter(Boolean)
            .join(", "),
        },
        ...(documentConfig?.toData?.phone
          ? [{ bold: false, text: `Phone: ${documentConfig?.toData?.phone}` }]
          : []),
        ...(documentConfig?.toData?.email
          ? [{ bold: false, text: `Email: ${documentConfig?.toData?.email}` }]
          : []),
        ...(documentConfig?.toData?.referenceid
          ? [
              {
                bold: false,
                text: "Reference No:",
                suffix: ` ${documentConfig?.toData.referenceid}`,
              },
            ]
          : []),
        ...(documentConfig?.toData?.gstnumber
          ? [
              {
                bold: true,
                text: `GST:`,
                suffix: ` ${documentConfig?.toData?.gstnumber}`,
              },
            ]
          : []),
        ...(documentConfig?.toData?.fssai
          ? [
              {
                bold: true,
                text: `FSSAI:`,
                suffix: ` ${documentConfig?.toData?.fssai || ""}`,
              },
            ]
          : []),
        ...(documentConfig?.toData?.cinnumber
          ? [
              {
                bold: true,
                text: `CIN:`,
                suffix: ` ${documentConfig?.toData?.cinnumber || ""}`,
              },
            ]
          : []),

        ...(documentConfig?.toData?.pannumber
          ? [
              {
                bold: true,
                text: `PAN:`,
                suffix: ` ${documentConfig?.toData?.pannumber || ""}`,
              },
            ]
          : []),
        ...(documentConfig?.toData?.state
          ? [
              {
                bold: true,
                text: `State:`,
                suffix: ` ${documentConfig?.toData?.state} [ State Code: ${
                  documentConfig?.toData?.statecode || ""
                } ]`,
              },
            ]
          : []),
      ];
    }
    const wrapText = (text, maxWidth) => doc.splitTextToSize(text, maxWidth);
    const lineHeight = 5;
    const renderDetails = (details, startX, startY) => {
      let y = startY;
      details.forEach(({ bold, text, suffix = "" }) => {
        const fullText = text + suffix;
        const lines = wrapText(fullText, sectionWidth);

        lines.forEach((line, index) => {
          if (index === 0 && suffix && bold) {
            const labelWidth = doc.getTextWidth(text);
            doc.setFont("Inter-Bold", "bold");
            doc.text(text, startX, y);
            doc.setFont("Inter-Regular", "normal");
            doc.text(suffix, startX + labelWidth, y);
          } else {
            doc.setFont(
              bold ? "Inter-Bold" : "Inter-Regular",
              bold ? "bold" : "normal",
            );
            doc.text(line, startX, y);
          }
          y += lineHeight;
        });
      });

      return y;
    };
    fromY = renderDetails(fromDetails, col1X, fromY);
    let shippingY = sectionTop + 5;
    if (hasSaleToData && optData?.isCustomerDisplay) {
      toY = renderDetails(toDetails, col2X, toY);
    }
    if (hasShipping) {
      const shippingDetails = [
        {
          bold: false,
          text: [
            documentConfig?.toData?.shippingAddress?.addressline1,
            documentConfig?.toData?.shippingAddress?.addressline2,
            documentConfig?.toData?.shippingAddress?.district,
            documentConfig?.toData?.shippingAddress?.state,
            documentConfig?.toData?.shippingAddress?.country,
          ]
            .filter(Boolean)
            .join(", "),
        },
        ...(documentConfig?.toData?.shippingAddress?.pincode
          ? [
              {
                bold: false,
                text: `- ${documentConfig?.toData?.shippingAddress?.pincode}`,
              },
            ]
          : []),
        ...(documentConfig?.toData?.state
          ? [
              {
                bold: true,
                text: "State:",
                suffix: ` ${documentConfig?.toData?.shippingAddress?.state} [ State Code: ${documentConfig?.toData?.shippingAddress?.statecode || ""} ]`,
              },
            ]
          : []),
      ];
      shippingY = renderDetails(shippingDetails, col3X, shippingY);
    }
    const maxSectionY = Math.max(fromY, toY, shippingY);
    // 3. Product Table
    const productBody = documentConfig?.items?.map((item, i) => {
      const qty = item.quantity || 1;
      const rate = item.soldprice;
      const landingCost = item.lineTotalLandingCost;
      const total = item.lineTotalSoldPrice;
      const desc = [
        `${item.title}`,
        ...(item.imode === "PRODUCT" && item.note ? [item.note] : []),
        ...(item.imode === "SERVICE" && item.description
          ? [item.description]
          : []),
        ...(item.hsnsac
          ? [`${item.imode === "SERVICE" ? "SAC" : "HSN"} : ${item.hsnsac}`]
          : []),

        // `MRP     : ₹${CurrencyConverter.toCurrency(item.mrp || 0, "INR")}`,
        ...(item.discount > 0 ? [`MRP     : ₹${item.mrp}`] : []),
        ...(item.discount > 0 ? [`Discount: - ₹${item.discount}`] : []),
      ].join("\n");

      return [
        i + 1,
        desc,
        `₹${rate}`,
        `${qty} ${(() => {
          const unitCode = item?.isSecondaryUnit
            ? item?.unitConfig?.secondaryUnitCode
            : item?.unitConfig?.primaryUnitCode;

          // return unitCode !== "unit" ? unitCode : "";
          return unitCode || "";
        })()}`,
        `₹${total}`,
      ];
    });

    const grandTotal = documentConfig?.grandTotal;
    // Add total row INSIDE the same table
    productBody.push([
      {
        content: "",
        colSpan: 2,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: "Total",
        styles: { halign: "right", fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        // content: globalData.totalqty,
        content: "",
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${grandTotal}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
    ]);
    autoTable(doc, {
      startY: maxSectionY,
      head: [["S.No", "Description", "Rate", "Qty", "Total"]],
      body: productBody,
      margin: { left: 6, right: 5 }, // add right margin if needed
      tableWidth: doc.internal.pageSize.getWidth() - 10,
      styles: {
        font: "Inter-Regular",
        fontStyle: "normal",
        fontSize: 9,
        halign: "middle",
        cellPadding: 2,
        lineColor: selectedTheme?.templateTheme?.borderColor,
        lineWidth: 0.2,
        textColor: "#041121",
      },
      headStyles: {
        fillColor: selectedTheme?.templateTheme?.primaryColor,
        textColor: selectedTheme?.templateTheme?.foregroundColor,
        fontStyle: "bold",
        font: "Inter-Bold",
        halign: "center",
        valign: "middle",
      },
      columnStyles: {
        0: { cellWidth: 13, halign: "center", valign: "middle" },
        1: { cellWidth: 127, halign: "left" },
        2: { cellWidth: 20, halign: "right", valign: "middle" },
        3: { cellWidth: 16, halign: "center", valign: "middle" },
        4: { cellWidth: 20, halign: "right", valign: "middle" },
      },
      willDrawCell: function (data) {
        if (data.column.index === 1 && data.section === "body") {
          const itemIndex = data.row.index;
          const item = data.saleitems?.[itemIndex];
          if (!item) return;

          const x = data.cell.x + 2;
          let y = data.cell.y + 4;
          const lineHeight = 4;
          const currency = CurrencyConverter;

          const lines = [
            { type: "title", text: item.title },
            ...(item.imode === "PRODUCT" && item.note
              ? [{ type: "description", text: item.note }]
              : []),
            ...(item.imode === "SERVICE" && item.description
              ? [{ type: "description", text: item.description }]
              : []),
            ...(item.hasnsac
              ? [
                  {
                    label: item.imode === "SERVICE" ? "SAC:" : "HSN:",
                    value: item.hasnsac,
                  },
                ]
              : []),
            {
              label: "MRP:",
              value: `₹${currency.toCurrency(item.mrp || 0, "INR")}`,
            },
            {
              label: "Discount:",
              value: `₹${currency.toCurrency(item.discount || 0, "INR")}`,
            },
          ];

          data.cell.text = [];
          lines.forEach((line) => {
            if (line.type === "title") {
              doc.setFont("Inter-Bold", "bold");
              doc.setFontSize(15);
              doc.setTextColor(0, 0, 0);
              doc.text(line.text, x, y);
              doc.setFontSize(9);
            } else {
              doc.setFont("Inter-Bold", "bold");
              doc.setFontSize(9);
              doc.setTextColor(0, 0, 0);
              doc.text(line.label, x, y);
              doc.setFont("Inter-Regular", "normal");
              doc.setTextColor(80, 80, 80);
              doc.text(line.value, x + 32, y);
            }
            y += lineHeight;
          });
        }
      },

      theme: "grid",
    });
    const isInterState =
      documentConfig?.fromData?.statecode &&
      globalData?.saleto?.statecode &&
      documentConfig?.fromData.statecode !== globalData?.saleto.statecode;
    const body = [
      [
        {
          content: "Total Amount In Words",
          styles: {
            fontStyle: "bold",
            font: "Inter-Bold",
            fontSize: 9,
            valign: "top",
          },
        },
        {
          content: "Grand Total",
          styles: { halign: "right", fontSize: 9 },
        },
        {
          content: `₹${grandTotal}`,
          styles: { halign: "right", valign: "middle", fontSize: 9 },
        },
      ],
      [
        {
          content: documentConfig?.amountInWords || "Zero",
          rowSpan: isInterState ? 3 : 4,
          styles: {
            halign: "center",
            valign: "middle",
            fontSize: 9,
          },
        },
        {
          content: "Grand Total (Rounded)",
          styles: { fontStyle: "bold", halign: "right", fontSize: 9 },
        },
        {
          content: `₹${grandTotal}`,
          styles: {
            halign: "right",
            valign: "middle",
            fontStyle: "bold",
            fontSize: 10,
          },
        },
      ],
    ];
    const afterProductsY = doc.lastAutoTable?.finalY + 0.4;
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginBottom = 20;
    const estimatedSummaryHeight = 25;
    let summaryStartY;
    let isSamePage = true;
    if (afterProductsY + estimatedSummaryHeight + marginBottom <= pageHeight) {
      summaryStartY = afterProductsY;
    } else {
      doc.addPage();
      summaryStartY = 20;
      isSamePage = false;
    }
    autoTable(doc, {
      startY: summaryStartY,
      body: body,
      pageBreak: "avoid",
      margin: { left: 6, right: 5 },
      tableWidth: doc.internal.pageSize.getWidth() - 10,
      styles: {
        font: "Inter-Regular",
        fontStyle: "normal",
        halign: "middle",
        cellPadding: 2,
        fontSize: 9,
        lineColor: selectedTheme?.templateTheme?.borderColor,
        lineWidth: 0.2,
        fillColor: selectedTheme?.templateTheme?.primaryColor,
        textColor: selectedTheme.templateTheme?.foregroundColor,
      },
      columnStyles: {
        0: { cellWidth: 103 },
        1: { cellWidth: 73, halign: "right" },
        2: { cellWidth: 20, halign: "center", valign: "middle" },
      },
      didParseCell: function (data) {
        if (data.row.index === 0 && isSamePage) {
          data.cell.styles.lineWidth = {
            top: 0,
            right: 0.2,
            bottom: 0.2,
            left: 0.2,
          };
        }
        const lastRowIndex = body.length - 1;
        if (data.section === "body") {
          if (
            data.row.index === lastRowIndex &&
            (data.column.index === 1 || data.column.index === 2)
          ) {
            // data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.font = "Inter-Bold";
            data.cell.styles.fontStyle = "bold";
          } else {
            data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.fillColor = "#ffffff";
            data.cell.styles.font = "Inter-Regular";
            data.cell.styles.fontStyle = "normal";
          }
        }
      },
      theme: "grid",
    });
    const afterSummaryY = doc.lastAutoTable.finalY;
    const pageHeight2 = doc.internal.pageSize.getHeight();
    const marginBottom2 = 20;
    const declarationHeight = 45;
    let finalY;
    if (afterSummaryY + declarationHeight + marginBottom2 > pageHeight2) {
      doc.addPage();
      finalY = 10;
    } else {
      finalY = afterSummaryY;
    }
    let currentY = finalY + 8;
    const TotalDiscount = globalData?.totaldiscount;
    if (parseFloat(data.totaldiscount) > 0) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      doc.text(`Your Total Discount : ₹${TotalDiscount}`, 105, currentY, {
        align: "center",
      });

      currentY += 2; // ONLY if discount exists
    }

    // ---------------- PAYMENT MODE TABLE (LEFT – 2 INCH STYLE) ----------------

    const paymentRows = [];

    const cashPaid = (data?.cashamount || 0) - (data?.cashchange || 0);

    const cardPaid = (data?.cardamount || 0) - (data?.cardchange || 0);

    const onlinePaid = (data?.onlineamount || 0) - (data?.onlinechange || 0);

    const upiPaid = (data?.upiamount || 0) - (data?.upichange || 0);

    const balanceDue =
      (data?.paylateramount || 0) - (data?.paylaterchange || 0);

    const cashAmt = CurrencyConverter.toCurrency(cashPaid || 0, "INR");
    const cardAmt = CurrencyConverter.toCurrency(cardPaid || 0, "INR");
    const onlineAmt = CurrencyConverter.toCurrency(onlinePaid || 0, "INR");
    const upiAmt = CurrencyConverter.toCurrency(upiPaid || 0, "INR");
    const balanceAmt = CurrencyConverter.toCurrency(balanceDue || 0, "INR");

    // condition based rows
    if (globalData?.cashPaid > 0) {
      paymentRows.push(["Cash", `₹${globalData?.cashPaid}`]);
    }

    if (globalData?.cardPaid > 0) {
      paymentRows.push(["Card", `₹${globalData?.cardPaid}`]);
    }

    if (globalData?.onlinePaid > 0) {
      paymentRows.push(["Online Amount", `₹${globalData?.onlinePaid}`]);
    }

    if (globalData?.upiPaid > 0) {
      paymentRows.push(["UPI", `₹${globalData?.upiPaid}`]);
    }

    if (globalData?.balanceDue > 0) {
      paymentRows.push(["Balance Due", `₹${globalData?.balanceDue}`]);
    }

    // draw table ONLY if rows exist
    if (paymentRows.length > 0 && optData?.isPayment && !isPreSale) {
      autoTable(doc, {
        startY: currentY,
        head: [["Payment Mode", ""]],
        body: paymentRows,
        margin: { left: 6 },
        tableWidth: 70,
        styles: {
          font: "Inter-Regular",
          fontSize: 8,
          cellPadding: 2,
          lineColor: selectedTheme?.templateTheme?.borderColor,
          lineWidth: 0.2,
          textColor: "#000",
        },
        headStyles: {
          fillColor: selectedTheme?.templateTheme?.primaryColor,
          textColor: selectedTheme?.templateTheme?.foregroundColor,
          font: "Inter-Bold",
          fontStyle: "bold",
          halign: "center",
        },
        columnStyles: {
          0: { cellWidth: 40, halign: "left" },
          1: { cellWidth: 30, halign: "right" },
        },
        theme: "grid",
      });

      currentY = doc.lastAutoTable.finalY + 6;
    } else {
      currentY += 5;
    }
    const leftX = padding;

    if (
      optData?.isBankDetails &&
      storeSettings?.paymentSettings?.bankDetails &&
      !isPreSale
    ) {
      const qrSize = 28;
      const gap = 10;
      let bankY = currentY;

      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text("Bank Details", leftX, bankY);

      bankY += 5;
      const bankDetails = [];

      if (storeSettings?.paymentSettings?.bankDetails?.beneficiaryName) {
        bankDetails.push({
          label: "Name",
          value: storeSettings.paymentSettings.bankDetails.beneficiaryName,
        });
      }

      if (storeSettings?.paymentSettings?.bankDetails?.accountNo) {
        bankDetails.push({
          label: "Account #",
          value: storeSettings.paymentSettings.bankDetails.accountNo,
        });
      }

      if (storeSettings?.paymentSettings?.bankDetails?.ifsc) {
        bankDetails.push({
          label: "IFSC",
          value: storeSettings.paymentSettings.bankDetails.ifsc,
        });
      }

      if (storeSettings?.paymentSettings?.upiId) {
        bankDetails.push({
          label: "UPI ID",
          value: storeSettings.paymentSettings.upiId,
        });
      }

      const labelWidthOffset = 18; // The gap width where the bold values will start aligning
      let maxTextWidth = doc.getTextWidth("Bank Details");

      bankDetails.forEach((item) => {
        // A. Draw Label (Regular weight, slightly lighter color)
        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(7);
        doc.setTextColor(0, 0, 0); // Medium grey
        doc.text(`${item.label} :`, leftX, bankY);

        // B. Draw Value (Bold weight, darker color, perfectly aligned to the right of labels)
        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(7);
        doc.setTextColor(0, 0, 0);
        doc.text(String(item.value || ""), leftX + labelWidthOffset, bankY);

        const completeLineWidth =
          labelWidthOffset + doc.getTextWidth(String(item.value || ""));
        maxTextWidth = Math.max(maxTextWidth, completeLineWidth);

        bankY += 4.5;
      });

      doc.setTextColor(0, 0, 0);

      const qrX = leftX + maxTextWidth + gap;
      const qrY = currentY - 3;

      if (qrCodeDataUrl) {
        doc.addImage(qrCodeDataUrl, "PNG", qrX, qrY, qrSize, qrSize);
      }
      currentY = Math.max(bankY, qrY + qrSize) + 6;
    }
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(10);
    doc.text("***** Thank You! Visit Us Again *****", pageWidth / 2, currentY, {
      align: "center",
    });
    if (storeSettings?.negobillBranding) {
      currentY += 5;
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      doc.text("Powerd By", pageWidth / 2, currentY, { align: "center" });
      currentY += 5;
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      doc.text("www.NegoBill.com", pageWidth / 2, currentY, {
        align: "center",
      });
    }
    currentY += 8;

    const contentWidth = pageWidth - padding * 2;

    // 70% for Terms
    const termsWidth = contentWidth * 0.7;

    // 30% for Signature
    const signWidth = contentWidth * 0.3;

    let startY = currentY;
    if (optData?.isRemark && documentConfig?.remarks) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.text("Remark", leftX, startY);
      doc.setDrawColor(
        selectedTheme?.templateTheme?.borderColor || [200, 200, 200],
      ); // e.g. [0, 0, 0] or your theme color
      doc.setLineWidth(0.1);
      const remarkLines = doc.splitTextToSize(
        capitalizeFirstLetter(documentConfig.remarks),
        termsWidth + 25,
      );

      const lineHeight = 4;
      const remarkHeight = remarkLines.length * lineHeight + 6;

      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7);

      let remarkY = startY + 4;

      remarkLines.forEach((line) => {
        doc.text(line, leftX, remarkY);
        remarkY += lineHeight;
      });

      // Move Terms below Remark
      startY += remarkHeight + 1;
    }
    if (terms?.length > 0 && !isPreSale) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(9);
      doc.text("Terms & Conditions", leftX, startY);

      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7);
      const splitTerms = doc.splitTextToSize(terms, termsWidth - 5);
      doc.text(splitTerms, leftX, startY + 4);
    }
    const rightX = pageWidth - padding;

    const boxTopY = currentY + 3;

    // Vertical positions
    const SIGN_Y = boxTopY; // Signature image
    const LABEL_Y = SIGN_Y + 8; // "Issued By, Signature"
    const STORE_Y = LABEL_Y + 4; // Store name

    // Fonts
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(8);

    // -------- 1️⃣ Signature Image FIRST ----------
    const signimg = uRLs.IMAGE_URL + storeSettings?.invoiceSettings?.signature;

    if (storeSettings?.invoiceSettings?.signature) {
      try {
        const response = await fetch(signimg);
        const blob = await response.blob();
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        const { width, height } = await loadImageDimensions(base64);

        const maxWidth = 50;
        const maxHeight = 10;

        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const imgWidth = width * ratio;
        const imgHeight = height * ratio;

        const format = signimg.endsWith(".png") ? "PNG" : "JPEG";
        const imgX = rightX - imgWidth;

        doc.addImage(base64, format, imgX, SIGN_Y, imgWidth, imgHeight);
      } catch (err) {
        console.warn("Image failed to load:", err);
      }
    }

    // -------- 2️⃣ Issued By, Signature ----------
    doc.text("Issued By, Signature", rightX, LABEL_Y + 4, { align: "right" });

    // -------- 3️⃣ Store Name ----------
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(9);

    const titleText = String(documentConfig?.fromData?.title || "");
    doc.text(titleText, rightX, STORE_Y + 4, { align: "right" });

    setDownload(false);
    // setPrint(false);
    return doc;
  };

  const generateinvoicePDF = async () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const padding = 7;
    const headerX = 2;
    const headerY = 2;
    const imagePath = uRLs?.IMAGE_URL + "profile/" + documentConfig?.image;

    if (documentConfig?.image) {
      try {
        // Convert image URL to base64
        const response = await fetch(imagePath);
        const blob = await response.blob();
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        // Load original dimensions
        const { width: naturalWidth, height: naturalHeight } =
          await loadImageDimensions(base64);

        // Resize logic
        const maxWidth = 50;
        const maxHeight = 10;
        let imgWidth = naturalWidth;
        let imgHeight = naturalHeight;
        const widthRatio = maxWidth / imgWidth;
        const heightRatio = maxHeight / imgHeight;
        const ratio = Math.min(widthRatio, heightRatio);
        imgWidth *= ratio;
        imgHeight *= ratio;

        // Determine format
        const getImageFormat = (path) => {
          const ext = path.split(".").pop().toLowerCase();
          if (ext === "jpg" || ext === "jpeg") return "JPEG";
          if (ext === "png") return "PNG";
          return "JPEG";
        };
        const format = getImageFormat(imagePath);

        // Add image to PDF
        doc.addImage(
          base64,
          format,
          headerX + padding,
          headerY + padding,
          imgWidth,
          imgHeight,
        );
      } catch (err) {
        console.warn("Image failed to load:", err);
      }
    }

    const invoiceFontSize = 20;
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(invoiceFontSize);
    // Estimate vertical alignment by adjusting for font size
    const textHeightOffset = invoiceFontSize * 0.55;
    const invoiceTextY = headerY + textHeightOffset;
    const invoiceX = pageWidth - padding;
    const invoiceText = documentTitle && documentTitle;
    const invoiceTextWidth = doc.getTextWidth(invoiceText);
    doc.text(invoiceText, invoiceX, invoiceTextY, { align: "right" });
    // If cancelled, show "CANCELLED" immediately to the right of "INVOICE"
    if (globalData?.status === "CANCELLED") {
      const cancelledFontSize = invoiceFontSize * 0.6;
      doc.setFontSize(cancelledFontSize);
      doc.setTextColor(220, 53, 69); // Bootstrap danger red
      doc.setFont("Inter-Bold", "bold");
      // Position CANCELLED right after INVOICE
      const cancelledX = invoiceX - invoiceTextWidth - 8; // 8 is spacing between words
      doc.text("CANCELLED", cancelledX, invoiceTextY, { align: "right" });
      // Reset styles
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(invoiceFontSize);
    }
    // Prepare font size for labels and values
    doc.setFontSize(10);
    const invoiceNoLabel = documentConfig?.numberLabel;
    const invoiceNoValue = documentConfig?.number;
    const invoiceDateLabel = "Date:";
    const invoiceDateValue = saleTime.date;
    // Measure total widths
    const invoiceNoLabelWidth = doc.getTextWidth(invoiceNoLabel);
    const invoiceNoValueWidth = doc.getTextWidth(invoiceNoValue);
    const invoiceDateLabelWidth = doc.getTextWidth(invoiceDateLabel);
    const invoiceDateValueWidth = doc.getTextWidth(invoiceDateValue);
    const gap = 10;
    const innerGap = 2;
    const invoiceRowY = 25;
    const totalTextWidth =
      invoiceNoLabelWidth +
      innerGap +
      invoiceNoValueWidth +
      gap +
      invoiceDateLabelWidth +
      innerGap +
      invoiceDateValueWidth;
    const invoiceRowX = pageWidth - padding - totalTextWidth;
    const lineStartX = padding;
    const lineEndX = invoiceRowX - 5;
    const lineY = invoiceRowY;
    // Middle line
    doc.setDrawColor(selectedTheme?.templateTheme?.primaryColor);
    doc.setLineWidth(2);
    doc.setLineCap("round");
    doc.line(lineStartX, lineY, lineEndX, lineY);

    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceNoLabel, invoiceRowX, invoiceRowY);
    doc.setFont("Inter-Regular", "normal");
    doc.text(
      invoiceNoValue,
      invoiceRowX + invoiceNoLabelWidth + innerGap,
      invoiceRowY,
    );
    const dateX =
      invoiceRowX + invoiceNoLabelWidth + innerGap + invoiceNoValueWidth + gap;

    doc.setFont("Inter-Bold", "bold");
    doc.text(invoiceDateLabel, dateX, invoiceRowY);

    doc.setFont("Inter-Regular", "normal");
    doc.text(
      invoiceDateValue,
      dateX + invoiceDateLabelWidth + innerGap,
      invoiceRowY,
    );
    const sectionTop = 35;
    const col1X = padding;
    const col2X = pageWidth / 3 + 2;
    const col3X = (pageWidth / 3) * 2 + 2;
    const midX = col2X; // keep midX for existing references
    const showFromDetails = !!(
      documentConfig?.fromData?.title ||
      documentConfig?.fromData?.addressline1 ||
      documentConfig?.fromData?.addressline2 ||
      documentConfig?.fromData?.district ||
      documentConfig?.fromData?.country ||
      documentConfig?.fromData?.pincode ||
      documentConfig?.fromData?.phone ||
      documentConfig?.fromData?.email ||
      documentConfig?.fromData?.gstnumber ||
      documentConfig?.fromData?.fssai ||
      documentConfig?.fromData?.pannumber ||
      documentConfig?.fromData?.state
    );
    // doc.setFont("Inter-Bold", "bold");
    // doc.setFontSize(10);
    // doc.text(documentConfig?.fromLabel, padding, sectionTop);
    doc.setFontSize(8);
    const hasSaleToData =
      documentConfig?.toData &&
      (documentConfig?.toData?.name ||
        documentConfig?.toData?.addressline1 ||
        documentConfig?.toData?.addressline2 ||
        documentConfig?.toData?.district ||
        documentConfig?.toData?.country ||
        documentConfig?.toData?.pincode ||
        documentConfig?.toData?.phone ||
        documentConfig?.toData?.email ||
        documentConfig?.toData?.gstnumber ||
        documentConfig?.toData?.state ||
        documentConfig?.toData?.statecode ||
        documentConfig?.toData?.referenceid);

    const hasShipping =
      documentConfig?.toData?.shippingAddress &&
      (documentConfig?.toData?.shippingAddress?.addressline1 ||
        documentConfig?.toData?.shippingAddress?.addressline2);

    if (hasSaleToData && optData?.isCustomerDisplay) {
      doc.setFontSize(10);
      doc.text(documentConfig?.toLabel, col2X, sectionTop);
    }
    if (hasShipping && optData?.isCustomerDisplay) {
      doc.setFontSize(10);
      doc.setFont("Inter-Bold", "bold");
      doc.text("Shipping To:", col3X, sectionTop);
    }
    doc.setFontSize(8);
    let fromY = sectionTop;
    let toY = sectionTop + 5;
    let fromDetails = [];
    if (showFromDetails) {
      fromDetails = [
        { bold: true, text: documentConfig?.fromData?.title || "-" },
        // Address will be dynamically split and inserted below
        {
          bold: false,
          text: `Phone: ${documentConfig?.fromData?.phone || "+91"}`,
        },
        {
          bold: false,
          text: `Email: ${documentConfig?.fromData?.email || ""}`,
        },
        {
          bold: true,
          text: `GST:`,
          suffix: ` ${documentConfig?.fromData?.gstnumber || ""}`,
        },
        {
          bold: true,
          text: `FSSAI:`,
          suffix: ` ${documentConfig?.fromData?.fssai || ""}`,
        },
        {
          bold: true,
          text: `PAN:`,
          suffix: ` ${documentConfig?.fromData?.pannumber || ""}`,
        },
        {
          bold: true,
          text: `State:`,
          suffix: ` ${documentConfig?.fromData?.state || ""} [ State Code: ${
            documentConfig?.fromData?.statecode || ""
          } ]`,
        },
      ];
    }
    const sectionGap = 12;
    const sectionWidth = pageWidth / 3 - padding - 4;
    if (showFromDetails) {
      const fromAddressWrapWidth = sectionWidth - 10;
      const rawAddress = [
        documentConfig?.fromData?.addressline1,
        documentConfig?.fromData?.addressline2,
        documentConfig?.fromData?.district,
        documentConfig?.fromData?.country,
        documentConfig?.fromData?.pincode
          ? `- ${documentConfig?.fromData.pincode}`
          : "",
      ]
        .filter(Boolean)
        .join(", ");

      // Wrap address to sectionWidth (same used in renderDetails)
      const wrappedAddress = doc.splitTextToSize(
        rawAddress,
        fromAddressWrapWidth,
      );

      // Insert wrapped address lines after the title (index 1)
      wrappedAddress.forEach((line, i) => {
        fromDetails.splice(1 + i, 0, { bold: false, text: line });
      });
    }
    let toDetails = [];
    if (hasSaleToData) {
      toDetails = [
        { bold: true, text: documentConfig?.toData?.name || "-" },
        {
          bold: false,
          text: [
            documentConfig?.toData?.addressline1,
            documentConfig?.toData?.addressline2,
            documentConfig?.toData?.district,
            documentConfig?.toData?.country,
            documentConfig?.toData?.pincode
              ? `- ${documentConfig?.toData.pincode}`
              : "",
          ]
            .filter(Boolean)
            .join(", "),
        },
        ...(documentConfig?.toData?.phone
          ? [{ bold: false, text: `Phone: ${documentConfig?.toData?.phone}` }]
          : []),
        ...(documentConfig?.toData?.email
          ? [{ bold: false, text: `Email: ${documentConfig?.toData?.email}` }]
          : []),
        ...(documentConfig?.toData?.referenceid
          ? [
              {
                bold: false,
                text: "Reference No:",
                suffix: ` ${documentConfig?.toData.referenceid}`,
              },
            ]
          : []),
        ...(documentConfig?.toData?.gstnumber
          ? [
              {
                bold: true,
                text: `GST:`,
                suffix: ` ${documentConfig?.toData?.gstnumber}`,
              },
            ]
          : []),
        ...(documentConfig?.toData?.fssai
          ? [
              {
                bold: true,
                text: `FSSAI:`,
                suffix: ` ${documentConfig?.toData?.fssai || ""}`,
              },
            ]
          : []),
        ...(documentConfig?.toData?.cinnumber
          ? [
              {
                bold: true,
                text: `CIN:`,
                suffix: ` ${documentConfig?.toData?.cinnumber || ""}`,
              },
            ]
          : []),

        ...(documentConfig?.toData?.pannumber
          ? [
              {
                bold: true,
                text: `PAN:`,
                suffix: ` ${documentConfig?.toData?.pannumber || ""}`,
              },
            ]
          : []),
        ...(documentConfig?.toData?.state
          ? [
              {
                bold: true,
                text: `State:`,
                suffix: ` ${documentConfig?.toData?.state} [ State Code: ${
                  documentConfig?.toData?.statecode || ""
                } ]`,
              },
            ]
          : []),
      ];
    }
    const wrapText = (text, maxWidth) => doc.splitTextToSize(text, maxWidth);
    const lineHeight = 4;

    const renderDetails = (details, startX, startY) => {
      let y = startY;
      details.forEach(({ bold, text, suffix = "" }) => {
        const fullText = text + suffix;
        const lines = wrapText(fullText, sectionWidth);
        lines.forEach((line, index) => {
          if (index === 0 && suffix && bold) {
            const labelWidth = doc.getTextWidth(text);
            doc.setFont("Inter-Bold", "bold");
            doc.text(text, startX, y);
            doc.setFont("Inter-Regular", "normal");
            doc.text(suffix, startX + labelWidth, y);
          } else {
            doc.setFont(
              bold ? "Inter-Bold" : "Inter-Regular",
              bold ? "bold" : "normal",
            );
            doc.text(line, startX, y);
          }
          y += lineHeight;
        });
      });

      return y;
    };
    fromY = renderDetails(fromDetails, col1X, fromY);
    let shippingY = sectionTop + 5;
    if (hasSaleToData && optData?.isCustomerDisplay) {
      toY = renderDetails(toDetails, col2X, toY);
    }
    if (hasShipping && optData?.isCustomerDisplay) {
      const shippingDetails = [
        {
          bold: false,
          text: [
            documentConfig?.toData?.shippingAddress?.addressline1,
            documentConfig?.toData?.shippingAddress?.addressline2,
            documentConfig?.toData?.shippingAddress?.district,
            documentConfig?.toData?.shippingAddress?.state,
            documentConfig?.toData?.shippingAddress?.country,
          ]
            .filter(Boolean)
            .join(", "),
        },
        ...(documentConfig?.toData?.shippingAddress?.pincode
          ? [
              {
                bold: false,
                text: `INDIA - ${documentConfig?.toData?.shippingAddress?.pincode}`,
              },
            ]
          : []),
        ...(documentConfig?.toData?.shippingAddress?.state
          ? [
              {
                bold: true,
                text: "State:",
                suffix: ` ${globalData?.saleto?.shippingAddress?.state} [ State Code: ${documentConfig?.toData?.shippingAddress?.statecode || ""} ]`,
              },
            ]
          : []),
      ];
      shippingY = renderDetails(shippingDetails, col3X, shippingY);
    }
    // Make table start below all three columns
    const maxSectionY = Math.max(fromY, toY, shippingY);
    // 3. Product Table
    const itemsList = documentConfig?.items || [];
    const productBody = itemsList?.map((item, i) => {
      const qty = item.quantity || 1;
      const landingCost = item?.lineTotalLandingCost;
      const rate = item.soldprice;
      const gross = item.lineTotalSoldPrice;
      const taxable = item.lineTotalBasePrice;
      const gstAmt = item.lineTotalTaxAmount;
      const total = item.lineTotalSoldPrice;
      const desc = [
        `${item.title}`,
        ...(item?.imode === "PRODUCT" && item?.note ? [item?.note] : []),
        ...(item?.imode === "SERVICE" && item?.description
          ? [item?.description]
          : []),
        ...(item?.hsnsac
          ? [`${item?.imode === "SERVICE" ? "SAC" : "HSN"} : ${item.hsnsac}`]
          : []),

        ...(item?.discount > 0 ? [`MRP     : ₹${item?.mrp}`] : []),
        ...(item?.discount > 0 ? [`Discount: - ₹${item?.discount}`] : []),
        // `GST     : ${item.taxpercentage}%`,
      ].join("\n");
      return [
        i + 1,
        desc,
        `₹${rate}`,
        `${qty} ${(() => {
          const unitCode = item?.isSecondaryUnit
            ? item?.unitConfig?.secondaryUnitCode
            : item?.unitConfig?.primaryUnitCode;

          // return unitCode !== "unit" ? unitCode : "";
          return unitCode || "";
        })()}`,
        `₹${gross}`,
        `₹${taxable}`,
        `₹${gstAmt}`,
        `₹${total}`,
      ];
    });

    const soldTotal = documentConfig?.totalSoldPrice;

    const baseTotal = documentConfig?.totalBasePrice;

    const taxTotal = documentConfig?.totalTaxAmount;

    const grandTotal = documentConfig?.grandTotal;

    // Add total row INSIDE the same table
    productBody.push([
      {
        content: "",
        colSpan: 2,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: "Total",
        styles: { halign: "right", fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: "",
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${soldTotal}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${baseTotal}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${taxTotal}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
      {
        content: `₹${grandTotal}`,
        styles: { fontStyle: "bold", font: "Inter-Bold" },
      },
    ]);
    autoTable(doc, {
      startY: maxSectionY,
      head: [
        [
          "S.No",
          "Description",
          "Rate",
          "Qty",
          "Gross Amount",
          "Taxable Value",
          "GST Amount",
          "Total",
        ],
      ],
      body: productBody,
      margin: { left: 6, right: 5 }, // add right margin if needed
      tableWidth: doc.internal.pageSize.getWidth() - 10,
      styles: {
        font: "Inter-Regular",
        fontStyle: "normal",
        fontSize: 9,
        halign: "middle",
        cellPadding: 2,
        lineColor: selectedTheme?.templateTheme?.borderColor,
        lineWidth: 0.2,
        textColor: "#041121",
      },
      headStyles: {
        fillColor: selectedTheme?.templateTheme?.primaryColor,
        textColor: selectedTheme.templateTheme?.foregroundColor,
        fontStyle: "bold",
        font: "Inter-Bold",
        halign: "center",
        valign: "middle",
      },
      columnStyles: {
        0: { cellWidth: 13, halign: "center", valign: "middle" },
        1: { cellWidth: 73, halign: "left" },
        2: { cellWidth: 20, halign: "right", valign: "middle" },
        3: { cellWidth: 13, halign: "center", valign: "middle" },
        4: { cellWidth: 19, halign: "right", valign: "middle" },
        5: { cellWidth: 19, halign: "right", valign: "middle" },
        6: { cellWidth: 19, halign: "right", valign: "middle" },
        7: { cellWidth: 20, halign: "right", valign: "middle" },
      },
      willDrawCell: function (data) {
        if (data.column.index === 1 && data.section === "body") {
          const itemIndex = data.row.index;
          const item = data.saleitems?.[itemIndex];
          if (!item) return;

          const x = data.cell.x + 2;
          let y = data.cell.y + 4;
          const lineHeight = 4;
          const currency = CurrencyConverter;

          const lines = [
            { type: "title", text: item.title },
            ...(item.imode === "PRODUCT" && item.note
              ? [{ type: "description", text: item.note }]
              : []),
            ...(item.imode === "SERVICE" && item.description
              ? [{ type: "description", text: item.description }]
              : []),
            ...(item.hasnsac
              ? [
                  {
                    label: item.imode === "SERVICE" ? "SAC:" : "HSN:",
                    value: item.hasnsac,
                  },
                ]
              : []),
            {
              label: "MRP:",
              value: `₹${currency.toCurrency(item.mrp || 0, "INR")}`,
            },
            {
              label: "Discount:",
              value: `₹${currency.toCurrency(item.discount || 0, "INR")}`,
            },
            {
              label: "GST:",
              value: `${item.taxpercentage || 0}%`,
            },
          ];
          data.cell.text = [];
          lines.forEach((line) => {
            if (line.type === "title") {
              doc.setFont("Inter-Bold", "bold");
              doc.setFontSize(15);
              doc.setTextColor(0, 0, 0);
              doc.text(line.text, x, y);
              doc.setFontSize(9);
            } else {
              doc.setFont("Inter-Bold", "bold");
              doc.setFontSize(9);
              doc.setTextColor(0, 0, 0);
              doc.text(line.label, x, y);
              doc.setFont("Inter-Regular", "normal");
              doc.setTextColor(80, 80, 80);
              doc.text(line.value, x + 32, y);
            }
            y += lineHeight;
          });
        }
      },

      theme: "grid",
    });

    const totalBase = documentConfig?.totalBasePrice;

    const igst = documentConfig?.igstAmount;

    const sgst = documentConfig?.sgstAmount;

    const cgst = documentConfig?.cgstAmount;

    const totalSold = documentConfig?.totalSoldPrice;

    const isInterState =
      data.salefrom?.statecode &&
      data.saleto?.statecode &&
      data.salefrom.statecode !== data.saleto.statecode;
    const body = [
      [
        {
          content: "Total Amount In Words",
          styles: {
            fontStyle: "bold",
            font: "Inter-Bold",
            fontSize: 9,
            valign: "top",
          },
        },
        {
          content: "Total Amount Before Tax",
          styles: { halign: "right", fontSize: 9 },
        },
        {
          content: `₹${totalBase}`,
          styles: { halign: "right", valign: "middle", fontSize: 9 },
        },
      ],
      [
        {
          content: documentConfig?.amountInWords || "Zero",
          rowSpan: isInterState ? 3 : 4,
          styles: {
            halign: "center",
            valign: "middle",
            fontSize: 9,
          },
        },
        {
          content: isInterState ? "IGST" : "SGST",
          styles: { halign: "right", fontSize: 9 },
        },
        {
          content: isInterState ? `₹${igst}` : `₹${sgst}`,
          styles: { halign: "right", valign: "middle", fontSize: 9 },
        },
      ],
    ];
    if (!isInterState) {
      body.push([
        { content: "CGST", styles: { halign: "right", fontSize: 9 } },
        {
          content: `₹${cgst}`,
          styles: { halign: "right", valign: "middle", fontSize: 9 },
        },
      ]);
    }
    // Add Total row
    body.push([
      { content: "Total", styles: { halign: "right", fontSize: 9 } },
      {
        content: `₹${totalSold}`,
        styles: { halign: "right", valign: "middle", fontSize: 9 },
      },
    ]);
    // Add Grand Total row
    body.push([
      {
        content: "Grand Total (Rounded)",
        styles: { fontStyle: "bold", halign: "right", fontSize: 9 },
      },
      {
        content: `₹${grandTotal}`,
        styles: {
          halign: "right",
          valign: "middle",
          fontStyle: "bold",
          fontSize: 10,
        },
      },
    ]);
    const afterProductsY = doc.lastAutoTable?.finalY + 0.3;
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginBottom = 20;
    const estimatedSummaryHeight = 50;
    let summaryStartY;
    let isSamePage = true;
    if (afterProductsY + estimatedSummaryHeight + marginBottom <= pageHeight) {
      summaryStartY = afterProductsY;
    } else {
      doc.addPage();
      summaryStartY = 20;
      isSamePage = false;
    }
    autoTable(doc, {
      startY: summaryStartY,
      body: body,
      pageBreak: "avoid",
      margin: { left: 6, right: 5 },
      tableWidth: doc.internal.pageSize.getWidth() - 10,
      styles: {
        font: "Inter-Regular",
        fontStyle: "normal",
        halign: "middle",
        cellPadding: 2,
        fontSize: 9,
        lineColor: selectedTheme?.templateTheme?.borderColor,
        lineWidth: 0.2,
        fillColor: selectedTheme?.templateTheme?.primaryColor,
        textColor: selectedTheme.templateTheme?.foregroundColor,
      },
      columnStyles: {
        0: { cellWidth: 103 },
        1: { cellWidth: 73, halign: "right" },
        2: { cellWidth: 20, halign: "center", valign: "middle" },
      },
      didParseCell: function (data) {
        if (data.row.index === 0 && isSamePage) {
          data.cell.styles.lineWidth = {
            top: 0,
            right: 0.2,
            bottom: 0.2,
            left: 0.2,
          };
        }
        const lastRowIndex = body.length - 1;
        if (data.section === "body") {
          if (
            data.row.index === lastRowIndex &&
            (data.column.index === 1 || data.column.index === 2)
          ) {
            // data.cell.styles.fillColor = "#f4f4f6";
            // data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.font = "Inter-Bold";
            data.cell.styles.fontStyle = "bold";
          } else {
            data.cell.styles.textColor = [0, 0, 0];
            data.cell.styles.fillColor = "#ffffff";
            data.cell.styles.font = "Inter-Regular";
            data.cell.styles.fontStyle = "normal";
          }
        }
      },
      theme: "grid",
    });
    // 0: { cellWidth: 110 }, 1: { cellWidth: 70, halign: "right" }, 2: { cellWidth: 20, halign: "center", valign: "middle" },
    const afterSummaryY = doc.lastAutoTable.finalY;
    const pageHeight2 = doc.internal.pageSize.getHeight();
    const marginBottom2 = 20;
    const declarationHeight = 45;
    let finalY;
    if (afterSummaryY + declarationHeight + marginBottom2 > pageHeight2) {
      doc.addPage();
      finalY = 10;
    } else {
      finalY = afterSummaryY;
    }
    let currentY = finalY + 8;
    const TotalDiscount = globalData.totaldiscount;
    if (parseFloat(data.totaldiscount) > 0) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      doc.text(`Your Total Discount : ₹${TotalDiscount}`, 105, currentY, {
        align: "center",
      });

      currentY += 2; // ONLY if discount exists
    }

    // ---------------- PAYMENT MODE TABLE (LEFT – 2 INCH STYLE) ----------------
    const paymentRows = [];

    const cashPaid = (data?.cashamount || 0) - (data?.cashchange || 0);

    const cardPaid = (data?.cardamount || 0) - (data?.cardchange || 0);

    const onlinePaid = (data?.onlineamount || 0) - (data?.onlinechange || 0);

    const upiPaid = (data?.upiamount || 0) - (data?.upichange || 0);

    const balanceDue =
      (data?.paylateramount || 0) - (data?.paylaterchange || 0);

    const cashAmt = CurrencyConverter.toCurrency(cashPaid || 0, "INR");
    const cardAmt = CurrencyConverter.toCurrency(cardPaid || 0, "INR");
    const onlineAmt = CurrencyConverter.toCurrency(onlinePaid || 0, "INR");
    const upiAmt = CurrencyConverter.toCurrency(upiPaid || 0, "INR");
    const balanceAmt = CurrencyConverter.toCurrency(balanceDue || 0, "INR");

    // condition based rows
    if (globalData?.cashPaid > 0) {
      paymentRows.push(["Cash", `₹${globalData?.cashPaid}`]);
    }

    if (globalData?.cardPaid > 0) {
      paymentRows.push(["Card", `₹${globalData?.cardPaid}`]);
    }

    if (globalData?.onlinePaid > 0) {
      paymentRows.push(["Online Amount", `₹${globalData?.onlinePaid}`]);
    }

    if (globalData?.upiPaid > 0) {
      paymentRows.push(["UPI", `₹${globalData?.upiPaid}`]);
    }

    if (globalData?.balanceDue > 0) {
      paymentRows.push(["Balance Due", `₹${globalData?.balanceDue}`]);
    }

    // draw table ONLY if rows exist
    if (paymentRows.length > 0 && optData?.isPayment && !isPreSale) {
      autoTable(doc, {
        startY: currentY,
        head: [["Payment Mode", ""]],
        body: paymentRows,
        margin: { left: 6 },
        tableWidth: 70,
        styles: {
          font: "Inter-Regular",
          fontSize: 8,
          cellPadding: 2,
          lineColor: selectedTheme?.templateTheme?.borderColor,
          lineWidth: 0.2,
          textColor: "#000",
        },
        headStyles: {
          fillColor: selectedTheme?.templateTheme?.primaryColor,
          textColor: selectedTheme?.templateTheme?.foregroundColor,
          font: "Inter-Bold",
          fontStyle: "bold",
          halign: "center",
        },
        columnStyles: {
          0: { cellWidth: 40, halign: "left" },
          1: { cellWidth: 30, halign: "right" },
        },
        theme: "grid",
      });

      currentY = doc.lastAutoTable.finalY + 6;
    } else {
      currentY += 5;
    }
    const leftX = padding;
    if (
      optData?.isBankDetails &&
      storeSettings?.paymentSettings?.bankDetails &&
      !isPreSale
    ) {
      const qrSize = 28;
      const gap = 10;
      let bankY = currentY;

      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.setTextColor(0, 0, 0);
      doc.text("Bank Details", leftX, bankY);

      bankY += 5;
      const bankDetails = [];

      if (storeSettings?.paymentSettings?.bankDetails?.beneficiaryName) {
        bankDetails.push({
          label: "Name",
          value: storeSettings.paymentSettings.bankDetails.beneficiaryName,
        });
      }

      if (storeSettings?.paymentSettings?.bankDetails?.accountNo) {
        bankDetails.push({
          label: "Account #",
          value: storeSettings.paymentSettings.bankDetails.accountNo,
        });
      }

      if (storeSettings?.paymentSettings?.bankDetails?.ifsc) {
        bankDetails.push({
          label: "IFSC",
          value: storeSettings.paymentSettings.bankDetails.ifsc,
        });
      }

      if (storeSettings?.paymentSettings?.upiId) {
        bankDetails.push({
          label: "UPI ID",
          value: storeSettings.paymentSettings.upiId,
        });
      }

      const labelWidthOffset = 18; // The gap width where the bold values will start aligning
      let maxTextWidth = doc.getTextWidth("Bank Details");

      bankDetails.forEach((item) => {
        // A. Draw Label (Regular weight, slightly lighter color)
        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(7);
        doc.setTextColor(0, 0, 0); // Medium grey
        doc.text(`${item.label} :`, leftX, bankY);

        // B. Draw Value (Bold weight, darker color, perfectly aligned to the right of labels)
        doc.setFont("Inter-Regular", "normal");
        doc.setFontSize(7);
        doc.setTextColor(0, 0, 0);
        doc.text(String(item.value || ""), leftX + labelWidthOffset, bankY);

        const completeLineWidth =
          labelWidthOffset + doc.getTextWidth(String(item.value || ""));
        maxTextWidth = Math.max(maxTextWidth, completeLineWidth);

        bankY += 4.5;
      });

      doc.setTextColor(0, 0, 0);

      const qrX = leftX + maxTextWidth + gap;
      const qrY = currentY - 3;

      if (qrCodeDataUrl) {
        doc.addImage(qrCodeDataUrl, "PNG", qrX, qrY, qrSize, qrSize);
      }
      currentY = Math.max(bankY, qrY + qrSize) + 6;
    }
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(10);
    doc.text("***** Thank You! Visit Us Again *****", pageWidth / 2, currentY, {
      align: "center",
    });
    if (storeSettings?.negobillBranding) {
      currentY += 5;
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      doc.text("Powerd By", pageWidth / 2, currentY, { align: "center" });
      currentY += 5;
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(10);
      doc.text("www.NegoBill.com", pageWidth / 2, currentY, {
        align: "center",
      });
    }
    currentY += 8;

    const contentWidth = pageWidth - padding * 2;

    // 70% for Terms
    const termsWidth = contentWidth * 0.7;

    // 30% for Signature
    const signWidth = contentWidth * 0.3;

    // const leftX = padding;

    let startY = currentY;
    if (optData?.isRemark && documentConfig?.remarks) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(8);
      doc.text("Remark", leftX, startY);
      doc.setDrawColor(
        selectedTheme?.templateTheme?.borderColor || [200, 200, 200],
      ); // e.g. [0, 0, 0] or your theme color
      doc.setLineWidth(0.1);
      const remarkLines = doc.splitTextToSize(
        capitalizeFirstLetter(documentConfig.remarks),
        termsWidth + 25,
      );

      const lineHeight = 4;
      const remarkHeight = remarkLines.length * lineHeight + 6;

      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7);

      let remarkY = startY + 4;

      remarkLines.forEach((line) => {
        doc.text(line, leftX, remarkY);
        remarkY += lineHeight;
      });

      // Move Terms below Remark
      startY += remarkHeight + 1;
    }
    if (terms?.length > 0 && !isPreSale) {
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(9);
      doc.text("Terms & Conditions", leftX, startY);

      doc.setFont("Inter-Regular", "normal");
      doc.setFontSize(7);
      const splitTerms = doc.splitTextToSize(terms, termsWidth - 5);
      doc.text(splitTerms, leftX, startY + 4);
    }
    // const boxTopY = footerY + 10;
    // const boxHeight = 25;
    // const boxLeftX = padding;
    // const boxRightX = pageWidth - padding;
    // const boxWidth = boxRightX - boxLeftX;
    // const boxMidX = boxLeftX + boxWidth / 2;

    // doc.setFontSize(10);
    // doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);
    // doc.setLineWidth(0.2);
    // doc.rect(boxLeftX, boxTopY, boxWidth, boxHeight);
    // doc.line(boxMidX, boxTopY, boxMidX, boxTopY + boxHeight);

    // const startY = boxTopY + 6;
    // const lineHeight2 = 5;
    // const leftContentWidth = boxMidX - boxLeftX - 10;
    // const rightContentWidth = boxRightX - boxMidX - 10;

    // doc.setFont("Inter-Bold", "bold");
    // doc.text("Declaration:", boxLeftX + 5, startY);

    // let declarationText =
    //   "We declare that this tax invoice shows the actual price of the goods described and that all particulars are true and correct.";
    // doc.setFont("Inter-Regular", "normal");
    // const leftLines = doc.splitTextToSize(declarationText, leftContentWidth);
    // leftLines.forEach((line, i) => {
    //   doc.text(line, boxLeftX + 5, startY + (i + 1) * lineHeight2);
    // });

    // doc.setFont("Inter-Regular", "normal");
    // let rightText = "* Computer Generated Document No sign Required";
    // const rightLines = doc.splitTextToSize(rightText, rightContentWidth);
    // rightLines.forEach((line, i) => {
    //   doc.text(line, boxRightX - 5, startY + i * lineHeight2, {
    //     align: "right",
    //   });
    // });
    //   let textY = footerY + 8; // Start after thank-you text
    //   if (terms?.length > 0) {
    //     doc.setFont("Inter-Bold", "bold");
    //     doc.setFontSize(9);
    //     doc.text("Terms & Conditions", 10, textY - 3);

    //   doc.setFont("Inter-Regular", "normal");
    //   doc.setFontSize(7);
    //   doc.text(terms, 13, textY);
    // }
    const rightX = pageWidth - padding;

    const boxTopY = currentY + 3;

    // Vertical positions
    const SIGN_Y = boxTopY; // Signature image
    const LABEL_Y = SIGN_Y + 8; // "Issued By, Signature"
    const STORE_Y = LABEL_Y + 4; // Store name

    // Fonts
    doc.setFont("Inter-Regular", "normal");
    doc.setFontSize(8);

    // -------- 1️⃣ Signature Image FIRST ----------
    const signimg = uRLs.IMAGE_URL + storeSettings?.invoiceSettings?.signature;

    if (storeSettings?.invoiceSettings?.signature) {
      try {
        const response = await fetch(signimg);
        const blob = await response.blob();
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        const { width, height } = await loadImageDimensions(base64);

        const maxWidth = 50;
        const maxHeight = 10;

        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const imgWidth = width * ratio;
        const imgHeight = height * ratio;

        const format = signimg.endsWith(".png") ? "PNG" : "JPEG";
        const imgX = rightX - imgWidth;

        doc.addImage(base64, format, imgX, SIGN_Y, imgWidth, imgHeight);
      } catch (err) {
        console.warn("Image failed to load:", err);
      }
    }

    // -------- 2️⃣ Issued By, Signature ----------
    doc.text("Issued By, Signature", rightX, LABEL_Y + 4, { align: "right" });

    // -------- 3️⃣ Store Name ----------
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(9);

    const titleText = String(documentConfig?.fromData?.title || "");
    doc.text(titleText, rightX, STORE_Y + 4, { align: "right" });

    setDownload(false);
    // setPrint(false);
    return doc;
  };

  const generatePDF =
    isBill_isTax && isPreSale ? generateinvoicePDF : generateBillingPDF;
  if (isReturnView) {
    return (
      <ReturnSaleInvoice
        isData={returnData} // This is the updated return sale data loaded by your hook
        selectedOption={selectedOption}
        onClose={handleClose}
        saleId={isData?._id}
        onDataUpdate={onDataUpdate}
        onDataChange={onDataChange}
        isActive={isActive}
      />
    );
  }
  return (
    <>
      <InvoiceModalLayout
        isOpen={isMainModalOpen}
        data={data}
        latestVersion={latestVersion}
        isBtnLoading={isBtnLoading}
        handleResetSale={handleResetSale}
        handleModeConfirm={handleModeConfirm}
        generateInvoice1={isPreSale ? generatePDF : generateinvoicePDF}
        generateBill1={generateBillingPDF}
        onClose={handleClose}
        {...invoiceData}
      >
        <InvoiceToggleActionCard
          optData={optData}
          setOptData={setOptData}
          setBilling={setBilling}
          setSelectTermalOption={setSelectTermalOption}
          setSelectHALFA4Option={setSelectHALFA4Option}
          {...invoiceData}
        />
        {saleLoading ? (
          <div
            className="d-flex justify-content-center"
            style={{
              overflowY: "auto",
              maxHeight: "100%",
              width: "100%",
              paddingRight: "12px",
              paddingLeft: "12px",
            }}
          >
            <CircularProgress size={20} className="text-primary" />
          </div>
        ) : (
          <div
            className="pt-2"
            style={{
              overflowY: "auto",
              maxHeight: "100%",
              width: "100%",
              paddingRight: "12px",
              paddingLeft: "12px",
            }}
          >
            {globalData.salemode === "INVOICE" ||
            (isPreSale && isBill_isTax) ||
            isBillReceipt ? (
              <>
                {selectedSize === "HALFA4" ? (
                  <>
                    <InvoicePreviewRenderer
                      selectedSize={selectedSize}
                      selectHALFA4Option={selectHALFA4Option}
                      data={data}
                      optData={optData}
                      selectedTheme={selectedTheme}
                    />
                  </>
                ) : (
                  <div className="tm_container">
                    <div className="tm_invoice_wrap">
                      <div className="tm_invoice tm_style1 tm_type1">
                        <div className="tm_invoice_in p-2">
                          <table width="100%" className="pdfcontent">
                            <tbody>
                              <tr>
                                <td width="50%" style={{ textAlign: "left" }}>
                                  <div className="tm_logo">
                                    {documentConfig?.image && (
                                      <img
                                        src={
                                          uRLs.IMAGE_URL +
                                          "profile/" +
                                          documentConfig?.image
                                        }
                                        className="img-rounded logo mb-0"
                                        height="30"
                                      />
                                    )}
                                  </div>
                                </td>
                                <td width="50%" style={{ textAlign: "right" }}>
                                  <div className="tm_primary_color font-20 fw-bold tm_text_uppercase">
                                    {documentConfig.title && (
                                      <>{documentConfig.title}</>
                                    )}
                                  </div>
                                  {globalData?.status === "CANCELLED" && (
                                    <span className="badge rounded-pill bg-label-danger mt-3 fs-15 tm_text_uppercase">
                                      {globalData.status}
                                    </span>
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div className="tm_invoice_info tm_mb20">
                            <div
                              className="tm_invoice_seperator tm_gray_bg"
                              style={{
                                backgroundColor:
                                  selectedTheme?.templateTheme?.primaryColor,
                              }}
                            ></div>
                            <div className="tm_invoice_info_list">
                              <p className="tm_invoice_number tm_m0 mb-0 mt-3">
                                <b className="tm_primary_color">
                                  {" "}
                                  {documentConfig?.numberLabel}{" "}
                                </b>{" "}
                                {documentConfig?.number}
                              </p>
                              <p className="tm_invoice_date tm_m0 mt-3">
                                <b className="tm_primary_color"> Date: </b>{" "}
                                {saleTime.date}
                              </p>
                            </div>
                          </div>
                          <table width="100%" className="pdfcontent">
                            <tbody>
                              <tr>
                                {documentConfig?.fromData && (
                                  <td
                                    width="30%"
                                    style={{ verticalAlign: "top" }}
                                  >
                                    {/* <div
                                    style={{
                                      fontSize: "14px",
                                      lineHeight: "22px",
                                      fontWeight: "600",
                                      marginBottom: "0px",
                                    }}
                                  >
                                    {invFrom}
                                  </div> */}
                                    {documentConfig?.fromData && (
                                      <>
                                        <div
                                          style={{
                                            fontSize: "12px",
                                            fontWeight: "600",
                                            marginBottom: "0px",
                                          }}
                                        >
                                          {documentConfig?.fromData?.title ||
                                            ""}
                                        </div>
                                        <div
                                          style={{
                                            fontSize: "12px",
                                            lineHeight: "18px",
                                            marginBottom: "0px",
                                          }}
                                        >
                                          <div>
                                            {documentConfig?.fromData
                                              ?.addressline1 || ""}{" "}
                                            {documentConfig?.fromData
                                              ?.addressline2 || ""}{" "}
                                            {documentConfig?.fromData
                                              ?.district || ""}{" "}
                                            {documentConfig?.fromData
                                              ?.country || ""}{" "}
                                            -{" "}
                                            {documentConfig?.fromData
                                              ?.pincode || ""}
                                          </div>
                                          <div>
                                            Phone: +91{" "}
                                            {documentConfig?.fromData?.phone ||
                                              ""}
                                          </div>
                                          <div>
                                            Email:{" "}
                                            {documentConfig?.fromData?.email ||
                                              ""}
                                          </div>
                                          {documentConfig?.fromData
                                            ?.referenceid && (
                                            <div>
                                              Reference No:{" "}
                                              {
                                                documentConfig?.fromData
                                                  ?.referenceid
                                              }
                                            </div>
                                          )}
                                          <div>
                                            <strong>GST:</strong>{" "}
                                            {documentConfig?.fromData
                                              ?.gstnumber || ""}
                                          </div>
                                          {documentConfig?.fromData?.fssai && (
                                            <div>
                                              <strong>FSSAI:</strong>{" "}
                                              {documentConfig?.fromData?.fssai}
                                            </div>
                                          )}
                                          <div>
                                            {documentConfig?.fromData
                                              ?.cinnumber && (
                                              <div>
                                                <strong>CIN:</strong>{" "}
                                                {
                                                  documentConfig?.fromData
                                                    ?.cinnumber
                                                }
                                              </div>
                                            )}
                                            <strong>PAN:</strong>{" "}
                                            {documentConfig?.fromData
                                              ?.pannumber || ""}
                                          </div>
                                          <div>
                                            <strong>State:</strong>{" "}
                                            {documentConfig?.fromData?.state ||
                                              ""}{" "}
                                            [ State Code :
                                            {documentConfig?.fromData
                                              ?.statecode || ""}{" "}
                                            ]
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </td>
                                )}
                                <td width="5%"></td>
                                {optData?.isCustomerDisplay && (
                                  <td
                                    width="30%"
                                    style={{ verticalAlign: "top" }}
                                  >
                                    {documentConfig?.toData &&
                                      (documentConfig.toData?.name ||
                                        documentConfig.toData?.addressline1 ||
                                        documentConfig.toData?.addressline2 ||
                                        documentConfig.toData?.state ||
                                        documentConfig.toData?.district ||
                                        documentConfig.toData?.country ||
                                        documentConfig.toData?.pincode ||
                                        documentConfig.toData?.phone ||
                                        documentConfig.toData?.email ||
                                        documentConfig.toData?.gstnumber ||
                                        documentConfig.toData?.statecode ||
                                        documentConfig.toData?.referenceid) && (
                                        <div>
                                          <div
                                            style={{
                                              fontSize: "14px",
                                              lineHeight: "22px",
                                              fontWeight: "600",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            {documentConfig?.toLabel}
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "600",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            {documentConfig.toData?.name || ""}
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              lineHeight: "18px",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            <div>
                                              {documentConfig.toData
                                                ?.addressline1 || ""}{" "}
                                              {documentConfig.toData
                                                ?.addressline2 || ""}{" "}
                                              {documentConfig.toData?.state ||
                                                ""}{" "}
                                              {documentConfig.toData
                                                ?.district || ""}{" "}
                                              {documentConfig.toData?.country ||
                                                ""}{" "}
                                              {documentConfig.toData?.country
                                                ? " - "
                                                : ""}{" "}
                                              {documentConfig.toData?.pincode ||
                                                ""}
                                            </div>
                                            {documentConfig.toData?.phone && (
                                              <div>
                                                Phone: +91{" "}
                                                {documentConfig.toData?.phone}
                                              </div>
                                            )}
                                            {documentConfig.toData?.email && (
                                              <div>
                                                Email:{" "}
                                                {documentConfig.toData?.email}
                                              </div>
                                            )}
                                            {documentConfig.toData
                                              ?.referenceid && (
                                              <div>
                                                Reference No:{" "}
                                                {
                                                  documentConfig.toData
                                                    ?.referenceid
                                                }
                                              </div>
                                            )}
                                            {documentConfig.toData
                                              ?.gstnumber && (
                                              <div>
                                                <strong>GST:</strong>{" "}
                                                {
                                                  documentConfig.toData
                                                    ?.gstnumber
                                                }
                                              </div>
                                            )}
                                            {documentConfig.toData?.fssai && (
                                              <div>
                                                <strong>FASSI:</strong>{" "}
                                                {documentConfig.toData?.fssai}
                                              </div>
                                            )}
                                            {documentConfig.toData
                                              ?.cinnumber && (
                                              <div>
                                                <strong>CIN:</strong>{" "}
                                                {
                                                  documentConfig.toData
                                                    ?.cinnumber
                                                }
                                              </div>
                                            )}
                                            {documentConfig.toData
                                              ?.pannumber && (
                                              <div>
                                                <strong>PAN:</strong>{" "}
                                                {
                                                  documentConfig.toData
                                                    ?.pannumber
                                                }
                                              </div>
                                            )}
                                            {documentConfig.toData?.state && (
                                              <div>
                                                <strong>State:</strong>{" "}
                                                {documentConfig.toData?.state} [
                                                State Code :
                                                {documentConfig.toData
                                                  ?.statecode || ""}{" "}
                                                ]
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                  </td>
                                )}
                                <td width="5%"></td>
                                {optData?.isCustomerDisplay && (
                                  <td
                                    width="30%"
                                    style={{ verticalAlign: "top" }}
                                  >
                                    {documentConfig.toData?.shippingAddress &&
                                      (documentConfig.toData?.shippingAddress
                                        ?.addressline1 ||
                                        documentConfig.toData?.shippingAddress
                                          ?.addressline2) && (
                                        <div>
                                          <div
                                            style={{
                                              fontSize: "14px",
                                              lineHeight: "22px",
                                              fontWeight: "600",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            Shipping To:
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              lineHeight: "18px",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            <div>
                                              {documentConfig.toData
                                                ?.shippingAddress
                                                ?.addressline1 || ""}{" "}
                                              {documentConfig.toData
                                                ?.shippingAddress
                                                ?.addressline2 || ""}{" "}
                                              {documentConfig.toData
                                                ?.shippingAddress?.state ||
                                                ""}{" "}
                                              {documentConfig.toData
                                                ?.shippingAddress?.district ||
                                                ""}{" "}
                                              {documentConfig.toData
                                                ?.shippingAddress?.country ||
                                                ""}{" "}
                                              -{" "}
                                              {documentConfig.toData
                                                ?.shippingAddress?.pincode ||
                                                ""}
                                            </div>
                                            {documentConfig.toData
                                              ?.shippingAddress?.state && (
                                              <div>
                                                <strong>State:</strong>{" "}
                                                {
                                                  documentConfig.toData
                                                    ?.shippingAddress?.state
                                                }{" "}
                                                [ State Code :
                                                {documentConfig.toData
                                                  ?.shippingAddress
                                                  ?.statecode || ""}{" "}
                                                ]
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                  </td>
                                )}
                              </tr>
                            </tbody>
                          </table>
                          <table
                            // className="items"
                            width="100%"
                            style={{
                              marginTop: "6px",
                              borderCollapse: "collapse",
                            }}
                            cellPadding="4"
                          >
                            <thead>
                              <tr>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "20px",
                                    textAlign: "center",
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  S.No
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "240px",
                                    textAlign: "center",
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  Description
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "120px",
                                    textAlign: "center",
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  Rate
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "50px",
                                    textAlign: "center",
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  Qty
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "100px",
                                    textAlign: "center",
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  Gross Amount
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "100px",
                                    textAlign: "center",
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  Taxable Value
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "30px",
                                    textAlign: "center",
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  GST(%)
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "100px",
                                    textAlign: "center",
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  GST Amount
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "100px",
                                    textAlign: "center",
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                  }}
                                >
                                  Total
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {documentConfig?.items?.map((product, index) => (
                                <tr key={index}>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    {index + 1}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "left",
                                      fontSize: "12px",
                                      width: "30%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    <div>{product.title}</div>
                                    {product.imode === "SERVICE" && (
                                      <div className="ms-0 fsz-10 lh-13 mb-1">
                                        {product.description}
                                      </div>
                                    )}
                                    {product.imode === "PRODUCT" &&
                                      product.note && (
                                        <div className="ms-0 fsz-10 mb-1">
                                          {product?.note}
                                        </div>
                                      )}
                                    {product?.hsnsac && (
                                      <div>
                                        <span className="fw-medium">
                                          {product?.imode === "SERVICE"
                                            ? "SAC:"
                                            : "HSN:"}
                                        </span>{" "}
                                        {product?.hsnsac}
                                      </div>
                                    )}
                                    {product?.discount > 0 && (
                                      <>
                                        <div>
                                          <span className="fw-medium">
                                            MRP :{" "}
                                          </span>{" "}
                                          ₹{product?.mrp}
                                        </div>
                                        <div>
                                          <span className="fw-medium">
                                            Discount :{" "}
                                          </span>{" "}
                                          - ₹{product?.discount}
                                        </div>
                                      </>
                                    )}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    ₹{product?.soldprice}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    {product?.quantity}
                                    <span className="font-11 ms-1">
                                      {(() => {
                                        const unitCode =
                                          product?.isSecondaryUnit
                                            ? product?.unitConfig
                                                ?.secondaryUnitCode
                                            : product?.unitConfig
                                                ?.primaryUnitCode;

                                        // return unitCode !== "unit" ? unitCode : "";
                                        return unitCode || "";
                                      })()}
                                    </span>
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    ₹{product?.lineTotalSoldPrice}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    ₹{product.lineTotalBasePrice}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    {product.taxpercentage}%
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    ₹{product.lineTotalTaxAmount}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    ₹{product.lineTotalSoldPrice}
                                  </td>
                                </tr>
                              ))}
                              <tr>
                                <td
                                  colSpan={2}
                                  className="force-style"
                                  style={{
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                ></td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  Total
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  {/* {globalData?.totalqty} */}
                                </td>

                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  ₹{documentConfig?.totalSoldPrice}
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  ₹{documentConfig?.totalBasePrice}
                                </td>
                                <td></td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  ₹{documentConfig?.totalTaxAmount}
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  ₹{documentConfig?.grandTotal}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "left",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                  colSpan="4"
                                >
                                  Total Amount In Words
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "right",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                  colSpan="4"
                                >
                                  Total Amount Before Tax
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  ₹{documentConfig?.totalBasePrice}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                  colSpan="5"
                                  rowSpan="5"
                                >
                                  {documentConfig?.amountInWords}
                                </td>
                              </tr>
                              {documentConfig?.fromData?.statecode &&
                              documentConfig?.toData?.statecode &&
                              documentConfig.fromData.statecode !==
                                documentConfig?.toData.statecode ? (
                                <tr>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "right",
                                      fontSize: "12px",
                                      fontWeight: 500,
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                    colSpan="3"
                                  >
                                    IGST
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      fontWeight: 500,
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    ₹{documentConfig?.igstAmount}
                                  </td>
                                </tr>
                              ) : (
                                <>
                                  <tr>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "right",
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                      colSpan="3"
                                    >
                                      SGST
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "center",
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      ₹{documentConfig?.sgstAmount}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "right",
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                      colSpan="3"
                                    >
                                      CGST
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "center",
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      ₹{documentConfig?.cgstAmount}
                                    </td>
                                  </tr>
                                </>
                              )}
                              <tr>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "right",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                  colSpan="3"
                                >
                                  TOTAL
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  ₹{documentConfig?.totalSoldPrice}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "right",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                  }}
                                  colSpan="3"
                                >
                                  Grand Total (Rounded)
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  ₹{documentConfig?.grandTotal}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <table width="100%">
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    textAlign: "center",
                                    padding: "8px",
                                    color: "black",
                                  }}
                                >
                                  Your Total Discount : ₹
                                  {documentConfig?.totalDiscount}
                                  {/* <br />
                                    <div className="mt-1 fs-20">
                                      ***** Thank You! Visit Us Again *****
                                    </div> */}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          {optData?.isPayment && data?.grandtotal > 0 && (
                            <table
                              className="items"
                              width="38%"
                              style={{
                                marginTop: "4px",
                                // borderCollapse: "collapse",
                              }}
                              cellPadding="4"
                            >
                              <thead>
                                <tr>
                                  <th
                                    colSpan={2}
                                    className="force-style"
                                    style={{
                                      width: "100%",
                                      textAlign: "center",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      "--th-bg":
                                        selectedTheme?.templateTheme
                                          ?.primaryColor,
                                      "--th-color":
                                        selectedTheme?.templateTheme
                                          ?.foregroundColor,
                                    }}
                                  >
                                    Payment Mode
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {(globalData.cashamount || 0) -
                                  (globalData.cashchange || 0) >
                                  0 && (
                                  <tr>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      Cash
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      ₹{globalData?.cashPaid}
                                    </td>
                                  </tr>
                                )}
                                {(globalData.cardamount || 0) -
                                  (globalData.cardchange || 0) >
                                  0 && (
                                  <tr>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      Card
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      ₹{globalData?.cardPaid}
                                    </td>
                                  </tr>
                                )}
                                {(globalData.onlineamount || 0) -
                                  (globalData.onlinechange || 0) >
                                  0 && (
                                  <tr>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      OnlineAmount
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        fontWeight: "600",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      ₹{globalData?.onlinePaid}
                                    </td>
                                  </tr>
                                )}
                                {(globalData?.upiamount || 0) -
                                  (globalData?.upichange || 0) >
                                  0 && (
                                  <tr>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      UPI
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        fontWeight: "600",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      ₹{globalData?.upiPaid}
                                    </td>
                                  </tr>
                                )}
                                {(globalData?.paylateramount || 0) -
                                  (globalData?.paylaterchange || 0) >
                                  0 && (
                                  <tr>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      BalanceDue
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "12px",
                                        width: "10%",
                                        fontWeight: "600",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      ₹{globalData?.balanceDue}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          )}
                          <div className="row mt-2">
                            <div className="col-3 p-2 pt-0  border-dark font-11">
                              {storeSettings?.paymentSettings?.bankDetails &&
                                optData?.isBankDetails &&
                                !isPreSale && (
                                  <>
                                    <strong>Bank Details:</strong>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        Name:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.beneficiaryName
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        Account #:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.accountNo
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        IFSC:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.ifsc
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        UPI ID:
                                      </span>

                                      {storeSettings?.paymentSettings?.upiId}
                                    </div>{" "}
                                  </>
                                )}
                            </div>
                            {qrCodeDataUrl &&
                              optData?.isBankDetails &&
                              !isPreSale && (
                                <div className="col-3 d-flex align-items-center justify-content-end">
                                  <img
                                    src={qrCodeDataUrl}
                                    alt="QR"
                                    style={{
                                      width: "100px",
                                      height: "100px",
                                    }}
                                  />
                                </div>
                              )}
                          </div>
                          <div className="mt-2 fs-20 d-flex justify-content-center fw-bold">
                            <span>***** Thank You! Visit Us Again *****</span>
                          </div>
                          {storeSettings?.negobillBranding && (
                            <>
                              <div className="mt-1 fs-20 d-flex justify-content-center fw-bold">
                                <span>Powered By</span>
                              </div>
                              <div className=" fs-20 d-flex justify-content-center fw-bold">
                                <span>www.NegoBill.com</span>
                              </div>
                            </>
                          )}
                          <table width="100%">
                            <tbody>
                              <tr>
                                {/* Left */}
                                <td
                                  width="70%"
                                  style={{
                                    verticalAlign: "top",
                                    paddingRight: "10px",
                                  }}
                                >
                                  {optData?.isRemark && documentConfig?.remarks ? (
                                    <>
                                      <div className="font-12 fw-600 text-black mb-1">
                                        Remark
                                      </div>

                                      <div
                                        className="font-12 mb-2 p-0"
                                        style={{
                                          whiteSpace: "pre-wrap",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {capitalizeFirstLetter(
                                          documentConfig?.remarks,
                                        )}
                                      </div>
                                    </>
                                  ) : null}

                                  {terms?.length > 0 && !isPreSale && (
                                    <>
                                      <div
                                        className="fs-13 fw-600"
                                        style={{
                                          textAlign: "left",
                                          color: "black",
                                        }}
                                      >
                                        Terms & Conditions
                                      </div>

                                      <div className="terms-box">{terms}</div>
                                    </>
                                  )}
                                </td>

                                {/* Right */}
                                <td
                                  width="30%"
                                  style={{
                                    verticalAlign: "top",
                                    textAlign: "right",
                                  }}
                                >
                                  {storeSettings?.invoiceSettings
                                    ?.signature && (
                                    <img
                                      src={
                                        uRLs.IMAGE_URL +
                                        storeSettings.invoiceSettings.signature
                                      }
                                      width={150}
                                      alt="Signature"
                                    />
                                  )}

                                  <div>Issued By, Signature</div>

                                  <div className="fw-bold">
                                    {documentConfig?.fromData?.title}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          {/* <table
                              className="items"
                              width="100%"
                              style={{ borderCollapse: "collapse" }}
                              cellPadding="8"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    className="force-style"
                                    style={{
                                      verticalAlign: "middle",
                                      width: "52.5%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      textAlign: "left",
                                      padding: "8px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: 600,
                                      }}
                                    >
                                      Declaration:
                                    </span>
                                    <br />
                                    <span style={{ fontSize: "12px" }}>
                                      We declare that this Tax Invoice shows the
                                      actual price of the goods described and
                                      that all particulars are true and correct.
                                    </span>
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      width: "50%",
                                      fontSize: "12px",
                                      fontWeight: "500",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      textAlign: "center",
                                      padding: "8px",
                                    }}
                                  >
                                    * Computer Generated Document No sign
                                    Required
                                  </td>
                                </tr>
                              </tbody>
                            </table> */}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : globalData.salemode === "BILL" ||
              (isPreSale && !isBill_isTax) ? (
              <>
                {selectedSize === "HALFA4" ? (
                  <>
                    <InvoicePreviewRenderer
                      selectedSize={selectedSize}
                      selectHALFA4Option={selectHALFA4Option}
                      data={data}
                      optData={optData}
                      selectedTheme={selectedTheme}
                    />
                  </>
                ) : (
                  <div className="tm_container">
                    <div className="tm_invoice_wrap">
                      <div className="tm_invoice tm_style1 tm_type1">
                        <div className="tm_invoice_in p-2">
                          <table width="100%" className="pdfcontent">
                            <tbody>
                              <tr>
                                <td width="50%" style={{ textAlign: "left" }}>
                                  <div className="tm_logo">
                                    {documentConfig?.image && (
                                      <img
                                        src={
                                          uRLs.IMAGE_URL +
                                          "profile/" +
                                          documentConfig?.image
                                        }
                                        className="img-rounded logo mb-0"
                                        height="30"
                                      />
                                    )}
                                  </div>
                                </td>
                                <td width="50%" style={{ textAlign: "right" }}>
                                  <div className="tm_primary_color font-20 fw-bold tm_text_uppercase">
                                    {documentConfig.title && (
                                      <>{documentConfig.title}</>
                                    )}
                                  </div>
                                  {globalData?.status === "CANCELLED" && (
                                    <span className="badge rounded-pill bg-label-danger mt-3 fs-15 tm_text_uppercase">
                                      {globalData.status}
                                    </span>
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div className="tm_invoice_info tm_mb20">
                            <div
                              className="tm_invoice_seperator tm_gray_bg"
                              style={{
                                backgroundColor:
                                  selectedTheme?.templateTheme?.primaryColor,
                              }}
                            ></div>
                            <div className="tm_invoice_info_list">
                              <p className="tm_invoice_number tm_m0 mb-0 mt-3">
                                <b className="tm_primary_color">
                                  {" "}
                                  {documentConfig?.numberLabel}{" "}
                                </b>{" "}
                                {documentConfig?.number}
                              </p>
                              <p className="tm_invoice_date tm_m0 mt-3">
                                <b className="tm_primary_color"> Date: </b>{" "}
                                {saleTime.date}
                              </p>
                            </div>
                          </div>
                          <table width="100%" className="pdfcontent">
                            <tbody>
                              <tr>
                                <td
                                  width="30%"
                                  style={{ verticalAlign: "top" }}
                                >
                                  {/* <div
                                    style={{
                                      fontSize: "14px",
                                      lineHeight: "22px",
                                      fontWeight: "600",
                                      marginBottom: "0px",
                                    }}
                                  >
                                    Bill From:
                                  </div> */}
                                  {documentConfig?.fromData && (
                                    <>
                                      <div
                                        style={{
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          marginBottom: "0px",
                                        }}
                                      >
                                        {documentConfig?.fromData?.title || ""}
                                      </div>
                                      <div
                                        style={{
                                          fontSize: "12px",
                                          lineHeight: "18px",
                                          marginBottom: "0px",
                                        }}
                                      >
                                        <div>
                                          {documentConfig?.fromData?.addressline1 ||
                                            ""}{" "}
                                          {documentConfig?.fromData?.addressline2 ||
                                            ""}{" "}
                                          {documentConfig?.fromData?.state || ""}{" "}
                                          {documentConfig?.fromData?.district || ""}{" "}
                                          {documentConfig?.fromData?.country || ""} -{" "}
                                          {documentConfig?.fromData?.pincode || ""}
                                        </div>
                                        <div>
                                          Phone: +91{" "}
                                          {documentConfig?.fromData?.phone || ""}
                                        </div>
                                        <div>
                                          Email:{" "}
                                          {documentConfig?.fromData?.email || ""}
                                        </div>
                                        {documentConfig?.fromData?.fssai && (
                                          <div>
                                            <strong>FSSAI:</strong>{" "}
                                            {documentConfig?.fromData?.fssai}
                                          </div>
                                        )}
                                        <div>
                                          <strong>PAN:</strong>{" "}
                                          {documentConfig?.fromData?.pannumber || ""}
                                        </div>
                                        <div>
                                          <strong>State:</strong>{" "}
                                          {documentConfig?.fromData?.state || ""} [
                                          State Code:{" "}
                                          {documentConfig?.fromData?.statecode || ""}{" "}
                                          ]
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </td>

                                <td width="5%"></td>
                                {optData?.isCustomerDisplay && (
                                  <td
                                    width="30%"
                                    style={{ verticalAlign: "top" }}
                                  >
                                    {documentConfig?.toData &&
                                      (documentConfig?.toData?.name ||
                                        documentConfig?.toData?.addressline1 ||
                                        documentConfig?.toData?.addressline2 ||
                                        documentConfig?.toData?.state ||
                                        documentConfig?.toData?.district ||
                                        documentConfig?.toData?.country ||
                                        documentConfig?.toData?.pincode ||
                                        documentConfig?.toData?.phone ||
                                        documentConfig?.toData?.email ||
                                        documentConfig?.toData?.statecode ||
                                        documentConfig?.toData
                                          ?.referenceid) && (
                                        <div>
                                          <div
                                            style={{
                                              fontSize: "14px",
                                              lineHeight: "22px",
                                              fontWeight: "600",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            {documentConfig?.toLabel}
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "600",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            {documentConfig?.toData?.name || ""}
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              lineHeight: "18px",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            <div>
                                              {documentConfig?.toData
                                                ?.addressline1 || ""}{" "}
                                              {documentConfig?.toData
                                                ?.addressline2 || ""}{" "}
                                              {documentConfig?.toData?.state ||
                                                ""}{" "}
                                              {documentConfig?.toData
                                                ?.district || ""}{" "}
                                              {documentConfig?.toData
                                                ?.country || ""}{" "}
                                              -{" "}
                                              {documentConfig?.toData
                                                ?.pincode || ""}
                                            </div>
                                            {documentConfig?.toData?.phone && (
                                              <div>
                                                Phone: +91{" "}
                                                {documentConfig?.toData?.phone}
                                              </div>
                                            )}
                                            {documentConfig?.toData?.email && (
                                              <div>
                                                Email:{" "}
                                                {documentConfig?.toData?.email}
                                              </div>
                                            )}
                                            {documentConfig?.toData
                                              ?.referenceid && (
                                              <div>
                                                Reference No:{" "}
                                                {
                                                  documentConfig?.toData
                                                    ?.referenceid
                                                }
                                              </div>
                                            )}
                                            {documentConfig?.toData
                                              ?.gstnumber && (
                                              <div>
                                                <strong>GST:</strong>{" "}
                                                {
                                                  documentConfig?.toData
                                                    ?.gstnumber
                                                }
                                              </div>
                                            )}
                                            {documentConfig?.toData?.fssai && (
                                              <div>
                                                <strong>FASSI:</strong>{" "}
                                                {documentConfig?.toData?.fssai}
                                              </div>
                                            )}
                                            {documentConfig?.toData
                                              ?.cinnumber && (
                                              <div>
                                                <strong>CIN:</strong>{" "}
                                                {
                                                  documentConfig?.toData
                                                    ?.cinnumber
                                                }
                                              </div>
                                            )}
                                            {documentConfig?.toData
                                              ?.pannumber && (
                                              <div>
                                                <strong>PAN:</strong>{" "}
                                                {
                                                  documentConfig?.toData
                                                    ?.pannumber
                                                }
                                              </div>
                                            )}
                                            {documentConfig?.toData?.state && (
                                              <div>
                                                <strong>State:</strong>{" "}
                                                {documentConfig?.toData?.state}{" "}
                                                [ State Code :
                                                {documentConfig?.toData
                                                  ?.statecode || ""}{" "}
                                                ]
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                  </td>
                                )}
                                <td width="5%"></td>
                                {optData?.isCustomerDisplay && (
                                  <td
                                    width="30%"
                                    style={{ verticalAlign: "top" }}
                                  >
                                    {documentConfig?.toData?.shippingAddress &&
                                      (documentConfig?.toData?.shippingAddress
                                        ?.addressline1 ||
                                        documentConfig?.toData?.shippingAddress
                                          ?.addressline2) && (
                                        <div>
                                          <div
                                            style={{
                                              fontSize: "14px",
                                              lineHeight: "22px",
                                              fontWeight: "600",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            Shipping To:
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              lineHeight: "18px",
                                              marginBottom: "0px",
                                            }}
                                          >
                                            <div>
                                              {documentConfig?.toData
                                                ?.shippingAddress
                                                ?.addressline1 || ""}{" "}
                                              {documentConfig?.toData
                                                ?.shippingAddress
                                                ?.addressline2 || ""}{" "}
                                              {documentConfig?.toData
                                                ?.shippingAddress?.state ||
                                                ""}{" "}
                                              {documentConfig?.toData
                                                ?.shippingAddress?.district ||
                                                ""}{" "}
                                              {documentConfig?.toData
                                                ?.shippingAddress?.country ||
                                                ""}{" "}
                                              -{" "}
                                              {documentConfig?.toData
                                                ?.shippingAddress?.pincode ||
                                                ""}
                                            </div>
                                            {documentConfig?.toData
                                              ?.shippingAddress?.state && (
                                              <div>
                                                <strong>State:</strong>{" "}
                                                {
                                                  documentConfig?.toData
                                                    ?.shippingAddress?.state
                                                }{" "}
                                                [ State Code :
                                                {documentConfig?.toData
                                                  ?.shippingAddress
                                                  ?.statecode || ""}{" "}
                                                ]
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                  </td>
                                )}
                              </tr>
                            </tbody>
                          </table>
                          <table
                            // className="items"
                            width="100%"
                            style={{
                              marginTop: "6px",
                              borderCollapse: "collapse",
                            }}
                            cellPadding="4"
                          >
                            <thead>
                              <tr>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "20px",
                                    textAlign: "center",
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  S.No
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  Description
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "60px",
                                    textAlign: "center",
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  Rate
                                </th>
                                <th
                                  className="force-style"
                                  style={{
                                    width: "60px",
                                    textAlign: "center",
                                    // background: "#f3f3f3",
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  Qty
                                </th>

                                <th
                                  className="force-style"
                                  style={{
                                    width: "60px",
                                    textAlign: "center",
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  Total
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {documentConfig?.items?.map((product, index) => (
                                <tr key={index}>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    {index + 1}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "left",
                                      fontSize: "12px",
                                      width: "45%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    <div>{product.title}</div>
                                    {product.imode === "SERVICE" && (
                                      <div className="ms-0 fsz-10 lh-13 mb-1">
                                        {product.description}
                                      </div>
                                    )}
                                    {product.imode === "PRODUCT" &&
                                      product.note && (
                                        <div className="ms-0 fs-12 text-truncate-description text-muted">
                                          {product?.note}
                                        </div>
                                      )}
                                    {product.hsnsac && (
                                      <div>
                                        <span className="fw-medium">
                                          {product.imode === "SERVICE"
                                            ? "SAC:"
                                            : "HSN:"}
                                        </span>{" "}
                                        {product.hsnsac}
                                      </div>
                                    )}
                                    {product.discount > 0 && (
                                      <>
                                        <div>
                                          <span className="fw-medium">
                                            MRP :{" "}
                                          </span>{" "}
                                          ₹{product?.mrp}
                                        </div>
                                        <div>
                                          <span className="fw-medium">
                                            Discount :{" "}
                                          </span>{" "}
                                          - ₹{product?.discount}
                                        </div>
                                      </>
                                    )}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    ₹{product?.soldprice}
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    {product?.quantity}
                                    <span className="font-11 ms-1">
                                      {(() => {
                                        const unitCode =
                                          product?.isSecondaryUnit
                                            ? product?.unitConfig
                                                ?.secondaryUnitCode
                                            : product?.unitConfig
                                                ?.primaryUnitCode;

                                        // return unitCode !== "unit" ? unitCode : "";
                                        return unitCode || "";
                                      })()}
                                    </span>
                                  </td>

                                  <td
                                    className="force-style"
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    }}
                                  >
                                    ₹{product?.lineTotalSoldPrice}
                                  </td>
                                </tr>
                              ))}
                              <tr>
                                <td
                                  colSpan={2}
                                  className="force-style"
                                  style={{
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                ></td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  Total
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  {/* {globalData?.totalqty}  */}
                                </td>

                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  ₹{documentConfig?.totalSoldPrice}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "left",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                  colSpan="2"
                                >
                                  Total Amount In Words
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "right",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                  colSpan="2"
                                >
                                  Grand Total
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  ₹{documentConfig?.grandTotal}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                  colSpan="2"
                                  rowSpan="5"
                                >
                                  {documentConfig?.amountInWords}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "right",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                  colSpan="2"
                                >
                                  Grand Total (Rounded)
                                </td>
                                <td
                                  className="force-style"
                                  style={{
                                    textAlign: "center",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    "--th-color":
                                      selectedTheme?.templateTheme
                                        ?.foregroundColor,
                                    "--th-bg":
                                      selectedTheme?.templateTheme
                                        ?.primaryColor,
                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                  }}
                                >
                                  ₹{documentConfig?.grandTotal}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <table width="100%">
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    textAlign: "center",
                                    padding: "8px",
                                    color: "black",
                                  }}
                                >
                                  Your Total Discount : ₹
                                  {documentConfig?.totalDiscount}
                                  {/* <br />
                                    <div className="mt-1 fs-20">
                                      ***** Thank You! Visit Us Again *****
                                    </div> */}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          {optData?.isPayment &&
                            data?.grandtotal > 0 &&
                            !isPreSale && (
                              <table
                                className="items"
                                width="38%"
                                style={{
                                  marginTop: "4px",
                                  // borderCollapse: "collapse",
                                }}
                                cellPadding="4"
                              >
                                <thead>
                                  <tr>
                                    <th
                                      colSpan={2}
                                      className="force-style"
                                      style={{
                                        width: "100%",
                                        textAlign: "center",
                                        "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                        "--th-bg":
                                          selectedTheme?.templateTheme
                                            ?.primaryColor,
                                        "--th-color":
                                          selectedTheme?.templateTheme
                                            ?.foregroundColor,
                                      }}
                                    >
                                      Payment Mode
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {(globalData.cashamount || 0) -
                                    (globalData.cashchange || 0) >
                                    0 && (
                                    <tr>
                                      <td
                                        className="force-style"
                                        style={{
                                          textAlign: "start",
                                          fontSize: "12px",
                                          width: "10%",
                                          "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                        }}
                                      >
                                        Cash
                                      </td>
                                      <td
                                        className="force-style"
                                        style={{
                                          textAlign: "start",
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          width: "10%",
                                          "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                        }}
                                      >
                                        ₹{globalData?.cashPaid}
                                      </td>
                                    </tr>
                                  )}
                                  {(globalData.cardamount || 0) -
                                    (globalData.cardchange || 0) >
                                    0 && (
                                    <tr>
                                      <td
                                        className="force-style"
                                        style={{
                                          textAlign: "start",
                                          fontSize: "12px",
                                          width: "10%",
                                          "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                        }}
                                      >
                                        Card
                                      </td>
                                      <td
                                        className="force-style"
                                        style={{
                                          textAlign: "start",
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          width: "10%",
                                          "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                        }}
                                      >
                                        ₹{globalData?.cardPaid}
                                      </td>
                                    </tr>
                                  )}
                                  {(globalData?.onlineamount || 0) -
                                    (globalData?.onlinechange || 0) >
                                    0 && (
                                    <tr>
                                      <td
                                        className="force-style"
                                        style={{
                                          textAlign: "start",
                                          fontSize: "12px",
                                          width: "10%",
                                          "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                        }}
                                      >
                                        OnlineAmount
                                      </td>
                                      <td
                                        className="force-style"
                                        style={{
                                          textAlign: "start",
                                          fontSize: "12px",
                                          width: "10%",
                                          fontWeight: "600",
                                          "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                        }}
                                      >
                                        ₹{globalData?.onlinePaid}
                                      </td>
                                    </tr>
                                  )}
                                  {(globalData?.upiamount || 0) -
                                    (globalData?.upichange || 0) >
                                    0 && (
                                    <tr>
                                      <td
                                        className="force-style"
                                        style={{
                                          textAlign: "start",
                                          fontSize: "12px",
                                          width: "10%",
                                          "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                        }}
                                      >
                                        UPI
                                      </td>
                                      <td
                                        className="force-style"
                                        style={{
                                          textAlign: "start",
                                          fontSize: "12px",
                                          width: "10%",
                                          fontWeight: "600",
                                          "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                        }}
                                      >
                                        ₹{globalData?.upiPaid}
                                      </td>
                                    </tr>
                                  )}
                                  {(globalData?.paylateramount || 0) -
                                    (globalData?.paylaterchange || 0) >
                                    0 && (
                                    <tr>
                                      <td
                                        className="force-style"
                                        style={{
                                          textAlign: "start",
                                          fontSize: "12px",
                                          width: "10%",
                                          "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                        }}
                                      >
                                        BalanceDue
                                      </td>
                                      <td
                                        className="force-style"
                                        style={{
                                          textAlign: "start",
                                          fontSize: "12px",
                                          width: "10%",
                                          fontWeight: "600",
                                          "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                        }}
                                      >
                                        ₹{globalData?.balanceDue}
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            )}
                          <div className="row mt-2">
                            <div className="col-3 p-2 pt-0  border-dark font-11">
                              {storeSettings?.paymentSettings?.bankDetails &&
                                optData?.isBankDetails &&
                                !isPreSale && (
                                  <>
                                    <strong>Bank Details:</strong>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        Name:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.beneficiaryName
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        Account #:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.accountNo
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        IFSC:
                                      </span>

                                      {
                                        storeSettings?.paymentSettings
                                          ?.bankDetails?.ifsc
                                      }
                                    </div>
                                    <div className="d-flex font-11">
                                      <span style={{ width: "80px" }}>
                                        UPI ID:
                                      </span>

                                      {storeSettings?.paymentSettings?.upiId}
                                    </div>{" "}
                                  </>
                                )}
                            </div>
                            {qrCodeDataUrl &&
                              optData?.isBankDetails &&
                              !isPreSale && (
                                <div className="col-3 d-flex align-items-center justify-content-end">
                                  <img
                                    src={qrCodeDataUrl}
                                    alt="QR"
                                    style={{
                                      width: "100px",
                                      height: "100px",
                                    }}
                                  />
                                </div>
                              )}
                          </div>
                          <div className="mt-2 fs-20 d-flex justify-content-center fw-bold">
                            <span>***** Thank You! Visit Us Again *****</span>
                          </div>

                          {storeSettings?.negobillBranding && (
                            <>
                              <div className="mt-1 fs-20 d-flex justify-content-center fw-bold">
                                <span>Powered By</span>
                              </div>
                              <div className=" fs-20 d-flex justify-content-center fw-bold">
                                <span>www.NegoBill.com</span>
                              </div>
                            </>
                          )}
                          <table width="100%">
                            <tbody>
                              <tr>
                                {/* Left */}
                                <td
                                  width="70%"
                                  style={{
                                    verticalAlign: "top",
                                    paddingRight: "10px",
                                  }}
                                >
                                  {optData?.isRemark && documentConfig?.remarks ? (
                                    <>
                                      <div className="font-12 fw-600 text-black mb-1">
                                        Remark
                                      </div>

                                      <div
                                        className="font-12 mb-2 p-0"
                                        style={{
                                          whiteSpace: "pre-wrap",
                                          wordBreak: "break-word",
                                        }}
                                      >
                                        {capitalizeFirstLetter(
                                          documentConfig?.remarks,
                                        )}
                                      </div>
                                    </>
                                  ) : null}

                                  {terms?.length > 0 && !isPreSale && (
                                    <>
                                      <div
                                        className="fs-13 fw-600"
                                        style={{
                                          textAlign: "left",
                                          color: "black",
                                        }}
                                      >
                                        Terms & Conditions
                                      </div>

                                      <div className="terms-box">{terms}</div>
                                    </>
                                  )}
                                </td>

                                {/* Right */}
                                <td
                                  width="30%"
                                  style={{
                                    verticalAlign: "top",
                                    textAlign: "right",
                                  }}
                                >
                                  {storeSettings?.invoiceSettings
                                    ?.signature && (
                                    <img
                                      src={
                                        uRLs.IMAGE_URL +
                                        storeSettings.invoiceSettings.signature
                                      }
                                      width={150}
                                      alt="Signature"
                                    />
                                  )}

                                  <div>Issued By, Signature</div>

                                  <div className="fw-bold">
                                    {documentConfig?.fromData?.title}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          {/* <table
                              className="items"
                              width="100%"
                              style={{ borderCollapse: "collapse" }}
                              cellPadding="8"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    className="force-style"
                                    style={{
                                      verticalAlign: "middle",
                                      width: "52.5%",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      textAlign: "left",
                                      padding: "8px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: 600,
                                      }}
                                    >
                                      Declaration:
                                    </span>
                                    <br />
                                    <span style={{ fontSize: "12px" }}>
                                      We declare that this bill recipet shows
                                      the actual price of the goods described
                                      and that all particulars are true and
                                      correct.
                                    </span>
                                  </td>
                                  <td
                                    className="force-style"
                                    style={{
                                      width: "50%",
                                      fontSize: "12px",
                                      fontWeight: "500",
                                      "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      textAlign: "center",
                                      padding: "8px",
                                    }}
                                  >
                                    * Computer Generated Document No sign
                                    Required
                                  </td>
                                </tr>
                              </tbody>
                            </table> */}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="default-content">
                <p>No content available for this sale mode.</p>
              </div>
            )}          
          </div>
        )}
        <InvoiceInfoSidebar
          {...invoiceData}
          isData={isData}
          handleSelectedReturnSale={handleSelectedReturnSale}
        />
      </InvoiceModalLayout>

      {showConfirm && (
        <Convertinvoice
          onClose={() => setShowConfirm(false)}
          onConfirm={() => handleGenerateInvoice(data)}
        />
      )}
      <PaySettleModal
        isOpen={isPaySettleModalOpen}
        data={data}
        setIsPaySettleModalOpen={setIsPaySettleModalOpen}
        setIsMainModalOpen={setIsMainModalOpen}
        isBtnLoading={isBtnLoading}
        setBtnLoading={setBtnLoading}
      />
    </>
  );
};

export default ProfessionalGSTInvoice;
